<template>
  <div class="panel-right" :dir="dir()">
    <div class="button-panel-components-right p-1" :data-show="this.showSidebar">
      <font-awesome-icon class="font-awesome-icon show-sidebar-icon" :icon="['fas', 'angle-right']"
                         @click="hideSidebar"></font-awesome-icon>
      <font-awesome-icon class="font-awesome-icon hide-sidebar-icon" :icon="['fas','angle-left']"
                         @click="show"></font-awesome-icon>
    </div>
    <div class="panel-components-right" v-show="this.showSidebar">
      <div class="container">

        <!--      add-->
        <!--      -> bloco-->
        <!--      -> elemento-->
        <!--      -> grupo de fonte-->
        <!--      settings-->
        <!--      -> style-->
        <!--      -> animation-->
        <!--      -> advanced-->
        <!--      pessoal-->
        <!--      -> bloco-->
        <!--      -> elementos-->

        <ul class="nav nav-tabs justify-content-center nav-tabs-options-config">
          <li class="nav-item">
            <a class="nav-link add-tab" data-toggle="tab" href="#add" id="tab-add-panel">
              {{ $t('ct-add')}}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link settings-tab" data-toggle="tab" href="#settings">
              {{ $t('ct-settings') }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#personal" @click="openInfoVideos">
              {{ $t('ct-personal') }}
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div id="add" class="tab-pane fade add-tab-content">
            <ul class="nav nav-tabs nav-tabs-outline justify-content-flex-start nav-tabs-options-element">

              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#addpanel" id="tab-add-panel-action">
                  {{ $t('ct-panel') }}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link add-element-tab" data-toggle="tab" href="#addelem" @click="checkIfElementsAreLoaded()">
                  {{ $t('ct-elements') }}
                </a>
              </li>
            </ul>


            <div class="tab-content tab-bg" id="addpanel-tab-list">
              <div id="addpanel" class="tab-pane fade internal-tab">

                <h6 class="mt-4 ml-4 mr-4 mb-0 add-panel-label">{{$t('ct-add-panel')}}</h6>
                <h6 class="m-4 add-panel-return" style="display: none" @click="showCategories()">
                  <span class="arrow left"></span>{{$t('ct-return')}}
                </h6>

                <button class="btn btn-dark m-4 add-blank-panel" data-ba-i="add-base-panel" @click="addBasePanel()" :dir="dir()">
                  <i class="svg-icon svgi-add-panel"></i>
                  {{ $t('ct-blank-panel') }}
                </button>

                <div class="place-categories">
                  <ul class="nav nav-tabs">
                    <div v-for="(element,index) in new_blocks" :key="index">
                      <li class="nav-item card-elem-to-add">
                        <a class="nav-link elem-to-add" data-toggle="collapse" :href="'#addBlock' + element.id"
                           :data-target="'#addBlock' + element.id" aria-expanded="false" @click="hideCategories()"
                           aria-controls="collapseOne">
                          {{$t('ct-panel-'+ element.title_translated)}}
                        </a>
                      </li>
                    </div>
                  </ul>
                </div>

                <div class="place-categories-blocks">
                  <ul class="nav nav-tabs">
                    <div v-for="(element,index) in new_blocks" :key="index" style="width: 300px">
                      <div :id="'addBlock' + element.id" class="collapse categories-c">
                        <h6 class="pl-4 pr-4 mb-0" style="border-top: 1px solid lightgray;width: 300px;padding-top: 30px">
                          {{$t('ct-panel-'+ element.title_translated)}}
                        </h6>
                        <div class="card-body">
                          <div v-for="(child,key) in element.items_active" :key="key" class="text-center">
                            <div @click="addDefaultBlock(child.config, 'default')"
                                 data-ba-i="add-template-panel"
                                 class="addElement add-style panel-item"
                                 :data-ref="child.name"
                                 :data-config="JSON.stringify(child.config)">
                              <!--                              <img :src="showThumbnail(child.thumbnail)" alt="">-->
                              <div class="element-to-add-panel"
                                   :style="{background: showThumbnail(child.thumbnail)}"></div>
                              <div class="title-panel">{{child.description}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>

              </div>
              <div id="addelem" class="tab-pane fade internal-tab add-element-tab-content"
                   style="overflow-x: hidden;">
                <h6 class="mt-4 ml-4 mr-4 mb-0 add-panel-label-elem">
                  {{ elementsLoaded ? $t('ct-add-element') : $t('ct-loading') + '...' }}
                </h6>
                <h6 class="m-4 add-panel-return-elem" style="display: none" @click="showElements()">
                  <span class="arrow left"></span>{{$t('ct-return')}}
                </h6>
                <template v-show="elementsLoaded">
                  <div class="place-categories-elem">
                    <ul class="nav nav-tabs">
                      <li class="nav-item card-elem-to-add" v-show="elementsLoaded">
                        <a class="nav-link elem-to-add" data-toggle="collapse" href="#addElementTexts"
                          data-target="#addElementTexts" aria-expanded="false" @click="hideElements()"
                          aria-controls="collapseOne">
                          <i class="mdi mdi-text-subject element-icon"></i>
                          {{ $t('ct-element-texts') }}
                        </a>
                      </li>
                      <div v-for="(element,index) in new_apps" :key="index">
                        <li class="nav-item card-elem-to-add" v-if="checkCategoryComponent(element)">
                          <a class="nav-link elem-to-add" data-toggle="collapse" :href="'#addElement' + element.id"
                            :data-target="'#addElement' + element.id" aria-expanded="false" @click="hideElements()"
                            aria-controls="collapseOne">
                            <i class="mdi element-icon"
                              :class="element.icon ? element.icon : 'mdi-checkbox-blank-circle'"/>
                            {{$t('ct-element-'+ element.title_translated)}}
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>

                  <div class="place-categories-blocks-elem">
                    <ul class="nav nav-tabs">
                      <div v-for="(element,index) in new_apps" :key="index" style="width: 300px">
                        <div :id="'addElement' + element.id" class="collapse elements-c">
                          <h6 class="elements-c-title pl-4 pr-4 mb-0">
                            {{$t('ct-element-'+ element.title_translated)}}
                            <a :href="element.tutorial_link"
                              target="_blank"
                              v-if="element.tutorial_link"
                              :title="$t('ct-element-open-tutorial-link')"
                            >
                              <i class="mdi mdi-help-circle-outline mr-3" ></i>
                            </a>
                          </h6>
                          <div class="card-body">
                            <div v-for="(child,key) in element.items_active" :key="key" class="text-center">
                              <div v-if="checkComponent(child)" class="addElement add-style" :data-ref="child.name"
                                  :data-childs="JSON.stringify(child.childs)"
                                  :data-config="JSON.stringify(child.config)">
                                <div class="element-to-add-panel"
                                    :style="{background: showThumbnail(child.thumbnail)}"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="width: 300px">
                        <div id="addElementTexts" class="collapse elements-c">
                          <h6 class="elements-c-title pl-4 pr-4 mb-0">
                            {{ $t('ct-element-texts') }}
                            <a v-if="$t(`ct-element-texts-link-tutorial`) !== 'ct-element-texts-link-tutorial'"
                              :href="$t(`ct-element-texts-link-tutorial`)"
                              target="_blank">
                              <i class="mdi mdi-help-circle-outline mr-3" ></i>
                            </a>
                          </h6>
                          <div class="card-body">
                            <div style="text-align: center;">
                              <div class="addElement add-style font-item-group" data-ref="TextComponent"
                                  :data-config='JSON.stringify({"top":"20px","left":"150px","order_mobile":2,"showDesktop":true,"showMobile":true,"tag":"h1","content":"<h1 class=\"default\" style=\"text-align: center;\">ct-title-h1</h1>","width":"500px","fontSizeMobile":"30px","animation":{"in":{"action":"time","time":0,"scroll":0,"effect":"none","speed":"slow","infinite":false},"out":{"action":"time","time":0,"scroll":0,"effect":"none","delay":"1","speed":"1","infinite":false}},"zIndex":"auto","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px"})'>
                                <h1 class="element-preview-font-group">{{$t('ct-title-h1')}}</h1>
                              </div>
                              <div class="addElement add-style font-item-group" data-ref="TextComponent"
                                  :data-config='JSON.stringify({"top":"20px","left":"150px","order_mobile":2,"showDesktop":true,"showMobile":true,"tag":"h2","content":"<h2 class=\"default\" style=\"text-align: center;\">ct-title-h2</h2>","width":"500px","fontSizeMobile":"28px","animation":{"in":{"action":"time","time":0,"scroll":0,"effect":"none","speed":"slow","infinite":false},"out":{"action":"time","time":0,"scroll":0,"effect":"none","delay":"1","speed":"1","infinite":false}},"zIndex":"auto","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px"})'>
                                <h2 class="element-preview-font-group">{{$t('ct-title-h2')}}</h2>
                              </div>
                              <div class="addElement add-style font-item-group" data-ref="TextComponent"
                                  :data-config='JSON.stringify({"top":"20px","left":"150px","order_mobile":2,"showDesktop":true,"showMobile":true,"tag":"h3","content":"<h3 class=\"default\" style=\"text-align: center;\">ct-title-h3</h3>","width":"500px","fontSizeMobile":"25px","animation":{"in":{"action":"time","time":0,"scroll":0,"effect":"none","speed":"slow","infinite":false},"out":{"action":"time","time":0,"scroll":0,"effect":"none","delay":"1","speed":"1","infinite":false}},"zIndex":"auto","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px"})'>
                                <h3 class="element-preview-font-group">{{$t('ct-title-h3')}}</h3>
                              </div>
                              <div class="addElement add-style font-item-group" data-ref="TextComponent"
                                  :data-config='JSON.stringify({"top":"20px","left":"150px","order_mobile":2,"showDesktop":true,"showMobile":true,"tag":"h4","content":"<h4 class=\"default\" style=\"text-align: center;\">ct-title-h4</h4>","width":"300px","fontSizeMobile":"20px","animation":{"in":{"action":"time","time":0,"scroll":0,"effect":"none","speed":"slow","infinite":false},"out":{"action":"time","time":0,"scroll":0,"effect":"none","delay":"1","speed":"1","infinite":false}},"zIndex":"auto","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px"})'>
                                <h4 class="element-preview-font-group">{{$t('ct-title-h4')}}</h4>
                              </div>
                              <div class="addElement add-style font-item-group" data-ref="TextComponent"
                                  :data-config='JSON.stringify({"top":"20px","left":"150px","order_mobile":2,"showDesktop":true,"showMobile":true,"tag":"h5","content":"<h5 class=\"default\" style=\"text-align: center;\">ct-title-h5</h5>","width":"300px","fontSizeMobile":"18px","animation":{"in":{"action":"time","time":0,"scroll":0,"effect":"none","speed":"slow","infinite":false},"out":{"action":"time","time":0,"scroll":0,"effect":"none","delay":"1","speed":"1","infinite":false}},"zIndex":"auto","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px"})'>
                                <h5 class="element-preview-font-group">{{$t('ct-title-h5')}}</h5>
                              </div>
                              <div class="addElement add-style font-item-group" data-ref="TextComponent"
                                  :data-config='JSON.stringify({"top":"20px","left":"150px","order_mobile":2,"showDesktop":true,"showMobile":true,"tag":"h6","content":"<h6 class=\"default\" style=\"text-align: center;\">ct-title-h6</h6>","width":"300px","fontSizeMobile":"15px","animation":{"in":{"action":"time","time":0,"scroll":0,"effect":"none","speed":"slow","infinite":false},"out":{"action":"time","time":0,"scroll":0,"effect":"none","delay":"1","speed":"1","infinite":false}},"zIndex":"auto","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px"})'>
                                <h6 class="element-preview-font-group">{{$t('ct-title-h6')}}</h6>
                              </div>
                              <div class="addElement add-style font-item-group" data-ref="TextComponent"
                                  :data-config='JSON.stringify({"top":"20px","left":"150px","order_mobile":2,"showDesktop":true,"showMobile":true,"tag":"p","content":"<p class=\"default\" style=\"text-align: left;\">ct-title-helper-p</p>","width":"400px","fontSizeMobile":"12px","animation":{"in":{"action":"time","time":0,"scroll":0,"effect":"none","speed":"slow","infinite":false},"out":{"action":"time","time":0,"scroll":0,"effect":"none","delay":"1","speed":"1","infinite":false}},"zIndex":"auto","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px"})'>
                                <p class="element-preview-font-group">{{$t('ct-title-helper-p')}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div id="settings" class="tab-pane fade settings-tab-content">
            <div id="settingsStyle" class="tab-pane fade internal-tab  settings-style-tab-content">

              <div id="accordionStyleElement">
                <div class="card">
                  <div class="tab-heading">
                    <h5 class="pl-2 ml-1">{{elementEdition}}</h5>
                    <div v-if="warning === true" class="ct-alert-container">
                        <br />
                        <div class="ct-alert-content">
                          {{$t('ct-high-complexity')}}
                        </div>
                    </div>
                  </div>

                  <blog-search-component-options v-if="activeSidebar === 'BlogSearchComponentOptions'" ref="BlogSearchComponentOptions"></blog-search-component-options>
                  <box-component-options v-if="activeSidebar === 'BoxComponentOptions'" ref="BoxComponentOptions"></box-component-options>
                  <box-hover-component-options v-if="activeSidebar === 'BoxHoverComponentOptions'" ref="BoxHoverComponentOptions"></box-hover-component-options>
                  <image-component-options v-if="activeSidebar === 'ImageComponentOptions'" ref="ImageComponentOptions"></image-component-options>
                  <image3D-component-options v-if="activeSidebar === 'Image3DComponentOptions'" ref="Image3DComponentOptions"></image3D-component-options>
                  <checkout-component-options v-if="activeSidebar === 'CheckoutComponentOptions'" ref="CheckoutComponentOptions"></checkout-component-options>
                  <panel-component-options v-if="activeSidebar === 'PanelComponentOptions'" ref="PanelComponentOptions"></panel-component-options>
                  <launch-app-component-options v-if="activeSidebar === 'LaunchAppComponentOptions'" ref="LaunchAppComponentOptions"></launch-app-component-options>
                  <video-component-options v-if="activeSidebar === 'VideoComponentOptions'" ref="VideoComponentOptions"></video-component-options>
                  <lottie-file-component-options v-if="activeSidebar === 'LottieFileComponentOptions'" ref="LottieFileComponentOptions"></lottie-file-component-options>
                  <floating-button-component-options v-if="activeSidebar === 'FloatingButtonComponentOptions'" ref="FloatingButtonComponentOptions"></floating-button-component-options>

                  <div
                    class="accordion-settings"
                    v-show="
                      resourcesActive.alignMenu ||
                      resourcesActive.label ||
                      resourcesActive.fullWidth ||
                      resourcesActive.fullHeight ||
                      resourcesActive.inlineHtml ||
                      resourcesActive.showLabel ||
                      resourcesActive.showTitle ||
                      resourcesActive.showDescription ||
                      resourcesActive.showPlaceholder ||
                      resourcesActive.showPlaceholder ||
                      resourcesActive.youtubeSrc ||
                      resourcesActive.SocialBar ||
                      resourcesActive.Blog ||
                      resourcesActive.PostBlog ||
                      resourcesActive.themeBlog ||
                      resourcesActive.vimeoSrc ||
                      resourcesActive.CheckBoxLoop ||
                      resourcesActive.backDrop ||
                      resourcesActive.checkBoxAutoPlay ||
                      resourcesActive.checkBoxControl ||
                      resourcesActive.startYoutube ||
                      resourcesActive.endYoutube ||
                      resourcesActive.wistiaSrc ||
                      resourcesActive.videlloSrc ||
                      resourcesActive.textarea ||
                      resourcesActive.imageSrc ||
                      resourcesActive.embedText ||
                      resourcesActive.vertical ||
                      resourcesActive.horizontal ||
                      resourcesActive.fontSizeMobile ||
                      resourcesActive.type ||
                      resourcesActive.theme ||
                      resourcesActive.date ||
                      resourcesActive.alt ||
                      resourcesActive.webinarId ||
                      resourcesActive.webinarSecret ||
                      resourcesActive.sbFacebook ||
                      resourcesActive.sbTwitter ||
                      resourcesActive.sbInstagram ||
                      resourcesActive.sbNewAba ||
                      resourcesActive.sbLinkedin ||
                      resourcesActive.spaceBetween ||
                      resourcesActive.orientation ||
                      resourcesActive.checkFacebook ||
                      resourcesActive.checkTwitter ||
                      resourcesActive.checkLinkedin ||
                      resourcesActive.checkInstagram ||
                      resourcesActive.title ||
                      resourcesActive.hours ||
                      resourcesActive.opacity ||
                      resourcesActive.timerSlider ||
                      resourcesActive.autoPlaySlider ||
                      resourcesActive.arrowOptions ||
                      resourcesActive.arrowColor ||
                      resourcesActive.textLogin ||
                      resourcesActive.textLogout ||
                      resourcesActive.columns ||
                      resourcesActive.paddingContainer ||
                      resourcesActive.imagesPerPage ||
                      resourcesActive.galleryTheme ||
                      resourcesActive.verticalMargin ||
                      resourcesActive.enableOnlyLink ||
                      resourcesActive.positionContainer ||
                      resourcesActive.horizontalMargin ||
                      resourcesActive.bottomMargin ||
                      resourcesActive.leftMargin ||
                      resourcesActive.alignMobile ||
                      resourcesActive.checkBoxTextBackgroundHover ||
                      resourcesActive.textBackgroundColorHover||
                      resourcesActive.isGradientText ||
                      resourcesActive.textGradientColor ||
                      (resourcesActive.textStyle && !resourcesActive.icon) ||
                      resourcesActive.tabContentTextStyle">
                    <div class="card-header pointer" id="headingGeneral" data-toggle="collapse"
                         data-target="#styleElementGeneral" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-general-settings') }}
                      </h5>
                    </div>
                    <div id="styleElementGeneral" class="collapse show" aria-labelledby="headingGeneral"
                         >
                      <div class="card-body">
                        <input-component ref="label" v-show="resourcesActive.label"></input-component>

                        <input-component ref="blogBtnText" v-show="resourcesActive.blogBtnText"></input-component>

                        <select-component ref="effectSlide" v-show="resourcesActive.effectSlide"></select-component>
                        <input-component type="number" min="0" ref="gapBetween"
                                         v-show="resourcesActive.effectSlide && element.internal_config.effectSlide === 'side-padding'"></input-component>
                        <input-component type="number" min="0" ref="marginBetween"
                                         v-show="resourcesActive.effectSlide && element.internal_config.effectSlide === 'side-padding'"></input-component>
                        <!-- banner slider -->
                        <select-component ref="theme" v-show="resourcesActive.date"></select-component> <!-- Timer -->
                        <select-component ref="type" v-show="resourcesActive.type"></select-component> <!-- Timer -->
                        <input-component type="text" ref="textDescription"
                                         v-show="resourcesActive.textDescription && resourcesActive.timer && resourcesActive.timer.theme === 'text'"></input-component>
                        <!-- Timer -->
                        <input-component type="date" ref="date"
                                         v-show="resourcesActive.date && resourcesActive.timer && resourcesActive.timer.type === 'decrease_date_end'"></input-component>
                        <!-- Timer -->
                        <input-component type="number" min="0" ref="days"
                                         v-show="resourcesActive.days && resourcesActive.timer && resourcesActive.timer.type !== 'decrease_date_end'"></input-component>
                        <!-- Timer -->
                        <select-component ref="hours" v-show="resourcesActive.hours"></select-component> <!-- Timer -->
                        <select-component ref="minutes" v-show="resourcesActive.minutes"></select-component>
                        <!-- Timer -->
                        <select-component ref="seconds"
                                          v-show="resourcesActive.seconds && resourcesActive.timer && resourcesActive.timer.type !== 'decrease_date_end'"></select-component>
                        <!-- Timer -->

                        <check-component ref="vertical" v-show="resourcesActive.vertical"></check-component>
                        <check-component ref="horizontal" v-show="resourcesActive.horizontal"></check-component>
                        <check-component ref="fullWidth" class="hide-resource-on-mobile"
                                         v-show="resourcesActive.fullWidth"></check-component>
                        <check-component ref="fullHeight" class="hide-resource-on-mobile"
                                         v-show="resourcesActive.fullHeight"></check-component>
                        <check-component ref="inlineHtml" v-show="resourcesActive.inlineHtml"></check-component>
                        <check-component ref="showLabel" v-show="resourcesActive.showLabel"></check-component>
                        <check-component ref="showTitle" v-show="resourcesActive.showTitle"></check-component>
                        <check-component ref="showDescription" v-show="resourcesActive.showDescription"></check-component>
                        <check-component ref="showPreviousButton" v-show="resourcesActive.showPreviousButton"></check-component>
                        <check-component ref="showPlaceholder"
                                         v-show="resourcesActive.showPlaceholder"></check-component>
                        <check-component ref="showTitleNav" v-show="resourcesActive.showTitleNav"></check-component>
                        <!-- Blog -->
                        <select-component ref="themeBlog" v-show="resourcesActive.themeBlog"></select-component>
                        <slider-component ref="blogPerPage" :max="20" :min="0"
                                          v-show="resourcesActive.blogPerPage"></slider-component>
                        <!--
                                                <blog-component ref="BlogComponent"
                                                                       v-show="resourcesActive.Blog"></blog-component> -->
                        <!-- Big menu-->
                        <slider-component ref="leftMargin" :max="20" :min="0"
                                          v-show="resourcesActive.leftMargin"></slider-component>
                        <slider-component ref="bottomMargin" :max="20" :min="0"
                                          v-show="resourcesActive.bottomMargin"></slider-component>

                        <check-component ref="enableOnlyLink"
                                         v-show="resourcesActive.enableOnlyLink"></check-component>

                        <link-component
                          v-show="resourcesActive.elementName === 'big-menu-place'"
                          ref="link"
                        />

                        <div
                          v-show="resourcesActive.elementName === 'big-menu-place' && !resourcesActive.PlaceMenu.enableOnlyLink ">
                          <input-radio-component ref="typeOpenContainer"
                                                 v-show="resourcesActive.typeOpenContainer"></input-radio-component>
                          <input-radio-component ref="positionContainer"
                                                 v-show="resourcesActive.positionContainer"></input-radio-component>
                        </div>

                        <input-component ref="blogInputText" :max="'15'"
                                         v-show="resourcesActive.blogInputText"></input-component>

                        <!-- <text-style-component ref="subTextStyle"
                                              v-show="resourcesActive.subTextStyle"></text-style-component> -->
                        <!-- Social Bar -->
                        <socialbar-component ref="SocialBarComponent"
                                             v-show="resourcesActive.SocialBar"></socialbar-component>
                        <check-component ref="sbNewAba"
                                         v-show="resourcesActive.sbNewAba"></check-component>
                        <!-- orientation SocialBar -->
                        <check-component class="hide-resource-on-mobile" ref="orientation"
                                         v-show="resourcesActive.orientation"></check-component>
                        <!-- Facebook-->
                        <check-component ref="checkFacebook" style="pa"
                                         v-show="resourcesActive.checkFacebook"></check-component>
                        <input-component ref="sbFacebook"
                                         v-show="resourcesActive.sbFacebook && resourcesActive.SocialBar.checkFacebook"></input-component>
                        <image-component ref="imageFacebook" class="imgSocialBar"
                                         v-show="resourcesActive.imageFacebook && resourcesActive.SocialBar.checkFacebook"></image-component>
                        <!-- Twitter-->
                        <check-component ref="checkTwitter"
                                         v-show="resourcesActive.checkTwitter"></check-component>
                        <input-component ref="sbTwitter"
                                         v-show="resourcesActive.sbTwitter && resourcesActive.SocialBar.checkTwitter"></input-component>
                        <image-component ref="imageTwitter" class="imgSocialBar"
                                         v-show="resourcesActive.imageTwitter && resourcesActive.SocialBar.checkTwitter"></image-component>
                        <!-- Instagram-->
                        <check-component ref="checkInstagram"
                                         v-show="resourcesActive.checkInstagram"></check-component>
                        <input-component ref="sbInstagram"
                                         v-show="resourcesActive.sbFacebook && resourcesActive.SocialBar.checkInstagram"></input-component>
                        <image-component ref="imageInstagram" class="imgSocialBar"
                                         v-show="resourcesActive.imageInstagram && resourcesActive.SocialBar.checkInstagram"></image-component>
                        <!-- Linkedin -->
                        <check-component ref="checkLinkedin"
                                         v-show="resourcesActive.checkLinkedin"></check-component>
                        <input-component ref="sbLinkedin"
                                         v-show="resourcesActive.sbLinkedin && resourcesActive.SocialBar.checkLinkedin"></input-component>
                        <image-component ref="imageLinkedin" class="imgSocialBar"
                                         v-show="resourcesActive.imageLinkedin && resourcesActive.SocialBar.checkLinkedin"></image-component>
                        <slider-component :max="60" :min="0" ref="spaceBetween" v-show="resourcesActive.spaceBetween"></slider-component>
                        <!-- end SocialBar -->
                        <!--  Youtube  -->
                        <youtube-src-component ref="youtubeSrc"
                                               v-show="resourcesActive.youtubeSrc"></youtube-src-component>
                        <input-component type="number" min="0" ref="startYoutube"
                                         v-show="resourcesActive.startYoutube"></input-component>
                        <input-component type="number" min="0" ref="endYoutube"
                                         v-show="resourcesActive.endYoutube"></input-component>
                        <check-component ref="checkBoxControl"
                                         v-show="resourcesActive.checkBoxControl"></check-component>

                        <!--  endYoutube  -->
                        <!--  Webinar  -->
                        <webinar-src-component ref="webinarSrc"
                                               v-show="resourcesActive.webinarSrc"></webinar-src-component>
                        <input-component ref="webinarId" v-show="resourcesActive.webinarId"></input-component>
                        <input-component ref="webinarSecret" v-show="resourcesActive.webinarSecret"></input-component>
                        <!--  endWebinar  -->
                        <!--  Wistia  -->
                        <wistia-src-component ref="wistiaSrc"
                                              v-show="resourcesActive.wistiaSrc"></wistia-src-component>
                        <!--  Vimeo  -->
                        <vimeo-src-component ref="vimeoSrc"
                                             v-show="resourcesActive.vimeoSrc"></vimeo-src-component>
                        <check-component ref="checkBoxAutoPlay"
                                         v-show="resourcesActive.checkBoxAutoPlay"></check-component>
                        <check-component ref="checkBoxLoop" v-show="resourcesActive.checkBoxLoop"></check-component>
                        <!--  endVimeo  -->
                        <!-- Vidello -->
                        <vidello-src-componenet ref="videlloSrc"
                                                v-show="resourcesActive.videlloSrc"></vidello-src-componenet>
                        <!-- endVidello -->

                        <input-component ref="embedText" v-show="resourcesActive.embedText"></input-component>
                        <input-component ref="alt" v-show="resourcesActive.alt"></input-component>
                        <input-component ref="title" v-show="resourcesActive.title"></input-component>
                        <text-area-component ref="textarea" v-show="resourcesActive.textarea"></text-area-component>

                        <image-component ref="imageSrc" v-show="resourcesActive.imageSrc"></image-component>

                        <!-- Slider-Gallery -->
                        <slider-component ref="timerSlider"
                                          v-show="resourcesActive.timerSlider && element.internal_config.autoPlaySlider"></slider-component>

                        <!-- Slider-Gallery -->
                        <check-component ref="autoPlaySlider" v-show="resourcesActive.autoPlaySlider"></check-component>

                        <!-- Slider-Galllery -->
                        <check-component ref="arrowOptions" v-show="resourcesActive.arrowOptions"/>
                        <box-color-component ref="arrowBackground" v-show="resourcesActive.arrowBackground"/>
                        <box-color-component ref="arrowColor" v-show="resourcesActive.arrowColor"/>
                        <slider-component ref="arrowSize" v-show="resourcesActive.arrowSize"/>

                        <!-- Image-Gallery -->
                        <input-radio-component type="text" ref="galleryTheme"
                                               v-show="resourcesActive.galleryTheme"></input-radio-component>

                        <!-- Image-Gallery -->
                        <input-component type="number" min="1" ref="imagesPerPage"
                                         v-show="resourcesActive.imagesPerPage"/>

                        <!-- Image-Gallery -->
                        <input-component type="number" min="1" ref="columns"
                                         v-show="resourcesActive.columns"/>

                        <!-- Image-Gallery -->
                        <slider-component ref="verticalMargin"
                                          v-show="resourcesActive.verticalMargin"></slider-component>

                        <!-- Image-Gallery -->
                        <slider-component ref="horizontalMargin"
                                          v-show="resourcesActive.horizontalMargin"></slider-component>
                        <slider-component ref="opacity" v-show="resourcesActive.opacity"></slider-component>
                        <slider-component ref="fontSizeMobile"
                                          v-show="resourcesActive.fontSizeMobile"></slider-component>
                        <align-menu-component ref="alignMobile" v-show="resourcesActive.alignMobile"
                                              icons="true"></align-menu-component>

                        <check-component ref="isGradientText" v-show = "resourcesActive.isGradientText" />
                        <box-color-component ref="textGradientColor" v-show="resourcesActive.textGradientColor && element.internal_config.isGradientText" />

                        <check-component ref="checkBoxTextBackgroundHover" v-show="resourcesActive.checkBoxTextBackgroundHover"/>
                        <box-color-component ref="textBackgroundColorHover" v-show="resourcesActive.textBackgroundColorHover && element.internal_config.checkBoxTextBackgroundHover" />

                        <!-- Members Area -->
                        <input-radio-component type="text" ref="withDropdown"
                                               v-show="resourcesActive.withDropdown"></input-radio-component>

                        <input-radio-component type="text" ref="actionsformat"
                                         v-show="resourcesActive.actionsformat"></input-radio-component>

                        <input-component type="text" ref="textLogin" max="20"
                                         v-show="resourcesActive.textLogin && ['login-register', 'login'].includes(resourcesActive.btnUser.actionsformat)"></input-component>

                        <icon-component ref="iconLogin" v-show="resourcesActive.iconLogin && ['login-register', 'login'].includes(resourcesActive.btnUser.actionsformat)"></icon-component>

                        <input-component type="text" ref="textRegister" max="20"
                                         v-show="resourcesActive.textRegister && ['login-register', 'register'].includes(resourcesActive.btnUser.actionsformat)"></input-component>
                        <icon-component ref="iconRegister" v-show="resourcesActive.iconRegister && ['login-register', 'register'].includes(resourcesActive.btnUser.actionsformat)"></icon-component>

                        <input-component type="text" ref="textLogout" max="20"
                                         v-show="resourcesActive.textLogout"></input-component>
                        <icon-component ref="iconLogout" v-show="resourcesActive.iconLogout"></icon-component>

                        <text-style-component ref="textStyle"
                                              v-show="resourcesActive.textStyle && !resourcesActive.icon"
                                              name="true"></text-style-component>

                        <input-radio-component ref="withRegards"
                                               v-show="resourcesActive.withRegards"></input-radio-component>

                        <input-component type="text" ref="textRegards" max="20"
                                         v-show="resourcesActive.textRegards && parseInt(resourcesActive.btnUser.withRegards)"></input-component>

                        <icon-component ref="iconRegards" v-show="resourcesActive.iconRegards && parseInt(resourcesActive.btnUser.withRegards)"></icon-component>

                        <text-style-component ref="btnUserTextStyle"
                                              v-show="resourcesActive.btnUserTextStyle" name="name"></text-style-component>

                        <text-style-component ref="containerUserInfoTextStyle"
                             v-show="resourcesActive.containerUserInfoTextStyle" name="name"></text-style-component>

                        <text-style-component ref="textStyle"
                                              v-show="resourcesActive.textStyle && !resourcesActive.icon"
                                              name="true"></text-style-component>

                        <text-style-component ref="dropdownUserTextStyle"
                                              v-show="resourcesActive.dropdownUserTextStyle && resourcesActive.btnUser && parseInt(resourcesActive.btnUser.withDropdown)"
                                              name="true"></text-style-component>

                        <text-style-component ref="tabNavTextStyle"
                                              v-show="resourcesActive.tabNavTextStyle"
                                              name="true"></text-style-component>

                        <text-style-component ref="tabContentTextStyle"
                                              v-show="resourcesActive.tabContentTextStyle"
                                              name="true"></text-style-component>

                        <padding-component ref="paddingContainer"
                                           v-show="resourcesActive.paddingContainer"></padding-component>
                        <!-- Menu -->
                        <align-menu-component ref="alignMenu"
                                              v-show="resourcesActive.alignMenu && element.internal_config.fullWidth"
                                              class="hide-resource-on-mobile"></align-menu-component>
                        <select-component ref="menuMobileEffect"
                                          v-show="resourcesActive.menuMobileEffect"></select-component>
                        <!-- BigMenu -->
                        <check-component ref="backDrop"
                                         v-show="resourcesActive.backDrop"></check-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.icon">
                    <div class="card-header pointer" id="headingButton" data-toggle="collapse"
                         data-target="#styleElementButton" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-button-headline') }}
                      </h5>
                    </div>
                    <div id="styleElementButton" class="collapse show" aria-labelledby="headingButton"
                         >
                      <div class="card-body">
                        <input-component ref="text" v-show="resourcesActive.text"></input-component>
                        <text-style-component ref="textStyle"
                                              v-show="resourcesActive.textStyle"></text-style-component>
                        <check-component ref="enableLineBreak"
                                         v-show="resourcesActive.enableLineBreak"></check-component>
                        <icon-component ref="icon" v-show="resourcesActive.icon"></icon-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.subtext">
                    <div class="card-header pointer" id="headingSubButton" data-toggle="collapse"
                         data-target="#styleElementSubButton" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-button-sub-headline') }}
                      </h5>
                    </div>
                    <div id="styleElementSubButton" class="collapse show" aria-labelledby="headingSubButton"
                         >
                      <div class="card-body">
                        <input-component ref="subtext" v-show="resourcesActive.subtext"></input-component>
                        <text-style-component ref="subTextStyle"
                                              v-show="resourcesActive.subTextStyle"></text-style-component>
                      </div>
                    </div>
                  </div>
                  <!-- Image-Gallery Navigation-->
                  <div
                    class="accordion-settings"
                    v-show="resourcesActive.navigationWithNumber && resourcesActive.navigationBackground && resourcesActive.navigationHover">
                    <div class="card-header pointer" id="headingNavigation" data-toggle="collapse"
                         data-target="#styleElementNavigation" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-navigation') }}
                      </h5>
                    </div>
                    <div id="styleElementNavigation" class="collapse show" aria-labelledby="headingNavigation"
                         >
                      <div class="card-body">
                        <check-component
                          ref="navigationWithNumber"
                          v-show="resourcesActive.navigationWithNumber"/>
                        <box-color-component
                          ref="navigationBackground"
                          v-show="resourcesActive.navigationBackground"/>
                        <box-color-component
                          ref="navigationHover"
                          v-show="resourcesActive.navigationHover"/>
                        <box-color-component
                          ref="navigationActive"
                          v-show="resourcesActive.navigationActive"/>
                      </div>
                    </div>
                  </div>
                  <!-- Fonts -->
                  <div
                    v-show="resourcesActive.labelTextStyle || resourcesActive.numberTextStyle || resourcesActive.fontColor"
                    class="hide-resource-on-mobile accordion-settings">
                    <div class="card-header pointer" id="headingFonts" data-toggle="collapse"
                         data-target="#styleElementFonts" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-fonts') }}
                      </h5>
                    </div>
                    <div id="styleElementFonts" class="collapse show" aria-labelledby="headingFonts"
                         >
                      <div class="card-body">
                        <text-style-component ref="numberTextStyle"
                                              v-show="resourcesActive.labelTextStyle && resourcesActive.timer && resourcesActive.timer.theme !== 'circles' && resourcesActive.timer.theme !== 'panels'"
                                              name="true"></text-style-component>
                        <text-style-component ref="labelTextStyle"
                                              v-show="resourcesActive.numberTextStyle && resourcesActive.timer && (resourcesActive.timer.theme !== 'circles' && resourcesActive.timer.theme !== 'panels')"
                                              name="true"></text-style-component>
                        <box-color-component ref="fontColor"
                                             v-show="resourcesActive.fontColor && resourcesActive.timer && (resourcesActive.timer.theme === 'circles' || resourcesActive.timer.theme === 'panels')"></box-color-component>
                        <box-color-component ref="fontColorLabel"
                                             v-show="resourcesActive.fontColorLabel && resourcesActive.timer && resourcesActive.timer.theme === 'panels'"></box-color-component>
                        <text-style-component ref="descTextStyle"
                                              v-show="resourcesActive.descTextStyle && resourcesActive.timer && resourcesActive.timer.theme === 'text'"></text-style-component>

                        <text-style-component ref="containerUserInfoTextStyle"
                                              v-show="resourcesActive.containerUserInfoTextStyle" name="true"></text-style-component>

                        <text-style-component ref="containerUserInfoTextStyleNavTab"
                                              v-show="resourcesActive.containerUserInfoTextStyleNavTab" name="true"></text-style-component>
                      </div>
                    </div>
                  </div>
                  <div
                    v-show="((resourcesActive.width || resourcesActive.height) && !resourcesActive.timer) ||  resourcesActive.timer && (resourcesActive.timer.theme === 'circles' || resourcesActive.timer.theme === 'panels')"
                    class="hide-resource-on-mobile accordion-settings">
                    <div class="card-header pointer" id="headingSize" data-toggle="collapse"
                         data-target="#styleElementSize" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-size') }}
                      </h5>
                    </div>
                    <div id="styleElementSize" class="collapse show" aria-labelledby="headingSize"
                         >
                      <div class="card-body"
                           v-show="resourcesActive.timer && resourcesActive.timer.theme === 'panels' && resourcesActive.timer.widthPanels">
                        <slider-component ref="widthPanels" v-show="resourcesActive.widthPanels"
                                          class="hide-resource-on-mobile"></slider-component>
                      </div>
                      <div class="card-body"
                           v-show="!resourcesActive.timer || (resourcesActive.timer && resourcesActive.timer.theme !== 'panels')">
                        <slider-component ref="widthNext"
                                          class="hide-resource-on-mobile" v-show="resourcesActive.widthNext"></slider-component>
                        <slider-component ref="heightNext" v-show="resourcesActive.heightNext"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="width" v-show="resourcesActive.width"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="height" v-show="resourcesActive.height"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="widthPrevious" v-show="resourcesActive.widthPrevious"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="heightPrevious" v-show="resourcesActive.heightPrevious"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="buttonMargin" class="hide-resource-on-mobile" v-show="resourcesActive.buttonMargin"></slider-component>

                        <slider-component ref="heightContainer" v-show="resourcesActive.heightContainer"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="widthContainer" v-show="resourcesActive.widthContainer"
                                          class="hide-resource-on-mobile"></slider-component>

                        <slider-component ref="minWidth" v-show="resourcesActive.minWidth"
                                          class="hide-resource-on-mobile"></slider-component>

                        <slider-component ref="size-nav" v-show="resourcesActive.sizeNav"/>
                        <slider-component ref="size-title-nav" v-show="resourcesActive.sizeTitleNav"/>

                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.minHeight">
                    <div class="card-header pointer" id="headingMinSize" data-toggle="collapse"
                         data-target="#styleElementMinHeight" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-minimun-size') }}
                      </h5>
                    </div>
                    <div id="styleElementMinHeight" class="collapse show" aria-labelledby="headingSize"
                         >
                      <div class="card-body">
                        <slider-component ref="minHeight" v-show="resourcesActive.minHeight"></slider-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.maxWidth">
                    <div class="card-header pointer" id="headingmaxWidth" data-toggle="collapse"
                         data-target="#styleElementmaxWidth" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-maximum-size') }}
                      </h5>
                    </div>
                    <div id="styleElementmaxWidth" class="collapse show" aria-labelledby="headingSize"
                         >
                      <div class="card-body">
                        <slider-component ref="maxWidth" v-show="resourcesActive.maxWidth"></slider-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.inputStyle">
                    <div class="card-header pointer" id="headingStyle" data-toggle="collapse"
                         data-target="#styleElementInputFormStyle" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-input-style') }}
                      </h5>
                    </div>
                    <div id="styleElementInputFormStyle" class="collapse show" aria-labelledby="headingStyle"
                         >
                      <div class="card-body">
                        <text-style-component ref="inputStyle"
                                              v-show="resourcesActive.inputStyle"></text-style-component>

                        <slider-component ref="inputHeight" v-show="resourcesActive.inputHeight"></slider-component>
                        <slider-component ref="textareaHeight" v-show="resourcesActive.textareaHeight"></slider-component>
                        <border-component ref="inputBorder" v-show="resourcesActive.inputBorder"></border-component>
                        <border-radius-component ref="inputRadius"
                                                 v-show="resourcesActive.inputRadius"></border-radius-component>
                        <box-color-component ref="inputColor"
                                             v-show="resourcesActive.inputColor"></box-color-component>
                        <box-color-component ref="labelStyle"
                                             v-show="resourcesActive.labelStyle"></box-color-component>
                        <box-color-component ref="placeholderColor"
                                             v-show="resourcesActive.placeholderColor"></box-color-component>
                      </div>
                    </div>
                  </div>
                  <div
                    class="accordion-settings"
                    v-show="(resourcesActive.backgroundColor && !resourcesActive.timer) || (resourcesActive.timer && resourcesActive.timer.theme !== 'simple' && resourcesActive.timer.theme !== 'text')">
                    <div class="card-header pointer" id="headingBackground" data-toggle="collapse"
                         data-target="#styleElementBackground" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-colors') }}
                      </h5>
                    </div>
                    <div id="styleElementBackground" class="collapse show" aria-labelledby="headingBackground"
                         >
                      <div class="card-body">
                        <box-color-component ref="backgroundColor"
                                             v-show="(resourcesActive.backgroundColor && !resourcesActive.timer) || (resourcesActive.backgroundColor && resourcesActive.timer && (resourcesActive.timer.theme !== 'simple' && resourcesActive.timer.theme !== 'text'))"></box-color-component>
                        <box-color-component ref="backgroundColorNext"
                                             v-show="resourcesActive.backgroundColorNext"></box-color-component>
                        <box-color-component ref="backgroundColorPrevious"
                                             v-show="resourcesActive.backgroundColorPrevious"></box-color-component>
                        <box-color-component ref="backgroundColorBar"
                                             v-show="resourcesActive.backgroundColorBar"></box-color-component>
                        <box-color-component ref="backgroundColorContainer"
                                             v-show="resourcesActive.backgroundColorContainer"></box-color-component>
                        <check-component ref="hover" v-show="resourcesActive.hover"></check-component>
                        <box-color-component ref="backgroundColorHover"
                                             v-show="resourcesActive.backgroundColorHover"></box-color-component>
                        <box-color-component ref="backgroundColorHoverNext"
                                             v-show="resourcesActive.backgroundColorHoverNext"></box-color-component>
                        <box-color-component ref="backgroundColorHoverPrevious"
                                             v-show="resourcesActive.backgroundColorHoverPrevious"></box-color-component>
                        <box-color-component ref="textColorHover"
                                             v-show="resourcesActive.textColorHover"></box-color-component>
                        <box-color-component ref="textColorHoverNext"
                                             v-show="resourcesActive.textColorHoverNext"></box-color-component>
                        <box-color-component ref="textColorHoverPrevious"
                                             v-show="resourcesActive.textColorHoverPrevious"></box-color-component>
                        <box-color-component ref="backgroundColorSelected"
                                             v-show="resourcesActive.backgroundColorSelected"></box-color-component>
                        <box-color-component ref="textColorSelected"
                                             v-show="resourcesActive.textColorSelected"></box-color-component>
                        <box-color-component ref="colorHoverReadMore"
                                             v-show="resourcesActive.colorHoverReadMore"></box-color-component>
                        <box-color-component ref="backgroundColorEffect"
                                             v-show="resourcesActive.backgroundColorEffect && resourcesActive.timer &&
                                             (resourcesActive.timer.theme === 'circles' || resourcesActive.timer.theme === 'squares')"></box-color-component>

                        <box-color-component ref="textColorTabActive"
                                             v-show="resourcesActive.textColorTabActive"></box-color-component>

                        <box-color-component ref="textColorHoverDropdown"
                                             v-show="resourcesActive.textColorHoverDropdown && resourcesActive.btnUser && parseInt(resourcesActive.btnUser.withDropdown)"></box-color-component>
                        <box-color-component ref="backgroundDropdownColor"
                                             v-show="resourcesActive.backgroundDropdownColor && resourcesActive.btnUser && parseInt(resourcesActive.btnUser.withDropdown)"></box-color-component>
                        <box-color-component ref="backgroundDropdownColorHover"
                                             v-show="resourcesActive.backgroundDropdownColorHover && resourcesActive.btnUser && parseInt(resourcesActive.btnUser.withDropdown)"></box-color-component>

                        <box-color-component ref="backgroundTabColor"
                                             v-show="resourcesActive.backgroundTabColor"></box-color-component>

                        <box-color-component ref="backgroundTabActiveColor"
                                             v-show="resourcesActive.backgroundTabActiveColor"></box-color-component>

                        <box-color-component ref="backgroundTabHoverColor"
                                             v-show="resourcesActive.backgroundTabHoverColor"></box-color-component>

                        <image-component ref="src" v-show="resourcesActive.src"></image-component>
                        <arrow-config-component ref="arrowConfig"
                                                v-show="resourcesActive.arrowConfig"></arrow-config-component>

                        <box-color-component ref="backgroundColorActiveNav"
                                             v-show="resourcesActive.backgroundColorActiveNav"></box-color-component>
                        <box-color-component ref="backgroundColorInactiveNav"
                                             v-show="resourcesActive.backgroundColorInactiveNav"></box-color-component>
                        <box-color-component ref="activeTextColorNav"
                                             v-show="resourcesActive.activeTextColorNav"></box-color-component>
                        <box-color-component ref="inactiveTextColorNav"
                                             v-show="resourcesActive.inactiveTextColorNav"></box-color-component>
                        <box-color-component ref="titleTextColorNav"
                                             v-show="resourcesActive.titleTextColorNav"></box-color-component>
                        <text-style-component ref="titleFormStyle"
                                              v-show="resourcesActive.titleFormStyle"
                                              name="true"></text-style-component>
                        <text-style-component ref="descriptionFormStyle"
                                              v-show="resourcesActive.descriptionFormStyle"
                                              name="true"></text-style-component>

                        <box-color-component ref="color-title-nav" v-show="resourcesActive.titleTextColorNav"/>
                      </div>
                    </div>
                  </div>
                  <div
                    class="accordion-settings"
                    v-show="resourcesActive.internalBackgroundColor">
                    <div class="card-header pointer" id="headinginternalBackground" data-toggle="collapse"
                         data-target="#styleElementinternalBackground" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-internal-background') }}
                      </h5>
                    </div>
                    <div id="styleElementinternalBackground" class="collapse show"
                         aria-labelledby="headinginternalBackground"
                         >
                      <div class="card-body">
                        <box-color-component ref="internalBackgroundColor"
                                             v-show="resourcesActive.internalBackgroundColor"></box-color-component>
                        <image-component ref="internalSrc" v-show="resourcesActive.internalSrc"></image-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.video">
                    <div class="card-header pointer" id="headingShadowVideo" data-toggle="collapse"
                         data-target="#styleElementvideo" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-video') }}
                      </h5>
                    </div>
                    <div id="styleElementvideo" class="collapse show" aria-labelledby="headingShadow"
                         >
                      <div class="card-body">
                        <video-component ref="video" v-show="resourcesActive.video"></video-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.border">
                    <div class="card-header pointer" id="headingBorder" data-toggle="collapse"
                         data-target="#styleElementBorder" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-border') }}
                      </h5>
                    </div>
                    <div id="styleElementBorder" class="collapse show" aria-labelledby="headingBorder"
                         >
                      <div class="card-body">
                        <border-component ref="border" v-show="resourcesActive.border"></border-component>
                        <border-component ref="borderNext" v-show="resourcesActive.borderNext"></border-component>
                        <border-component ref="borderPrevious" v-show="resourcesActive.borderPrevious"></border-component>
                        <border-component ref="dropdownBorder" v-show="resourcesActive.dropdownBorder && resourcesActive.btnUser && parseInt(resourcesActive.btnUser.withDropdown)"></border-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.borderRadius">
                    <div class="card-header pointer" id="headingRadius" data-toggle="collapse"
                         data-target="#styleElementBorderRadius" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-radius') }}
                      </h5>
                    </div>
                    <div id="styleElementBorderRadius" class="collapse show" aria-labelledby="headingRadius"
                         >
                      <div class="card-body">
                        <border-radius-component ref="borderRadius"
                                                 v-show="resourcesActive.borderRadius"></border-radius-component>
                        <border-radius-component ref="borderRadiusNext"
                                                 v-show="resourcesActive.borderRadiusNext"></border-radius-component>
                        <border-radius-component ref="borderRadiusPrevious"
                                                 v-show="resourcesActive.borderRadiusPrevious"></border-radius-component>
                        <border-radius-component ref="borderRadiusNav"
                                                 v-show="resourcesActive.borderRadiusNav"></border-radius-component>
                        <border-radius-component ref="dropdownBorderRadius"
                                                 v-show="resourcesActive.dropdownBorderRadius && resourcesActive.btnUser && parseInt(resourcesActive.btnUser.withDropdown)" name="name"></border-radius-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.borderContainer">
                    <div class="card-header pointer" id="headingBorderContainer" data-toggle="collapse"
                         data-target="#styleElementBorderContainer" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-border-container') }}
                      </h5>
                    </div>
                    <div id="styleElementBorderContainer" class="collapse show" aria-labelledby="headingBorderContainer"
                         >
                      <div class="card-body">
                        <border-component ref="borderContainer"
                                          v-show="resourcesActive.borderContainer"></border-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.borderRadiusContainer">
                    <div class="card-header pointer" id="headingRadiusContainer" data-toggle="collapse"
                         data-target="#styleElementBorderRadiusContainer" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-radius-container') }}
                      </h5>
                    </div>
                    <div id="styleElementBorderRadiusContainer" class="collapse show"
                         aria-labelledby="headingRadiusContainer"
                         >
                      <div class="card-body">
                        <border-radius-component ref="borderRadiusContainer"
                                                 v-show="resourcesActive.borderRadiusContainer"></border-radius-component>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-settings" v-show="resourcesActive.iconNext">
                    <div class="card-header pointer" id="headingNextButton" data-toggle="collapse"
                         data-target="#styleElementNextButton" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-button-next') }}
                      </h5>
                    </div>
                    <div id="styleElementNextButton" class="collapse show" aria-labelledby="headingButton"
                         >
                      <div class="card-body">
                        <input-component ref="textNext" v-show="resourcesActive.textNext"></input-component>
                        <text-style-component ref="textStyleNext"
                                              v-show="resourcesActive.textStyleNext"></text-style-component>
                        <icon-component ref="iconNext" v-show="resourcesActive.iconNext"></icon-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.iconPrevious">
                    <div class="card-header pointer" id="previousButton" data-toggle="collapse"
                         data-target="#styleElementPreviousButton" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-button-previous') }}
                      </h5>
                    </div>
                    <div id="styleElementPreviousButton" class="collapse show" aria-labelledby="headingButton"
                         >
                      <div class="card-body">
                        <input-component ref="textPrevious" v-show="resourcesActive.textPrevious"></input-component>
                        <text-style-component ref="textStylePrevious"
                                              v-show="resourcesActive.textStylePrevious"></text-style-component>
                        <icon-component ref="iconPrevious" v-show="resourcesActive.iconPrevious"></icon-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.brandImage || resourcesActive.brandPosition">
                    <div class="card-header pointer" id="headingBrand" data-toggle="collapse"
                         data-target="#styleElementBrand" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-brand-menu') }}
                      </h5>
                    </div>
                    <div id="styleElementBrand" class="collapse show" aria-labelledby="headingBrand"
                         >
                      <div class="card-body">
                        <image-component ref="brandImage" v-show="resourcesActive.brandImage"></image-component>
                        <align-menu-component ref="brandPosition"
                                              v-show="resourcesActive.brandPosition"></align-menu-component>
                        <slider-component ref="brandWidth" v-show="resourcesActive.brandWidth"></slider-component>
                      </div>
                    </div>
                  </div>
                  <div
                    class="accordion-settings"
                    v-show="resourcesActive.burguerMenuPosition || resourcesActive.burguerMenuIcon || resourcesActive.burguerMenuCloseIcon  || resourcesActive.burguerMenuColor || resourcesActive.burguerMenuBackground">
                    <div class="card-header pointer" id="headingburguerMenu" data-toggle="collapse"
                         data-target="#styleElementburguerMenu" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ burguerTranslation }}
                      </h5>
                    </div>
                    <div id="styleElementburguerMenu" class="collapse show" aria-labelledby="headingburguerMenu"
                         >
                      <div class="card-body">
                        <slider-component ref="sizeIcon" v-show="resourcesActive.sizeIcon"></slider-component>
                        <align-menu-component ref="burguerMenuPosition"
                                              v-show="resourcesActive.burguerMenuPosition"></align-menu-component>
                        <icon-component ref="burguerMenuIcon" v-show="resourcesActive.burguerMenuIcon"></icon-component>
                        <check-component ref="showBurguerMenuCloseIcon"
                                         v-show="resourcesActive.showBurguerMenuCloseIcon"></check-component>
                        <box-color-component ref="burguerMenuColor"
                                             v-show="resourcesActive.burguerMenuColor"></box-color-component>
                        <box-color-component ref="burguerMenuBackground"
                                             v-show="resourcesActive.burguerMenuBackground"></box-color-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.textCounter">
                    <div class="card-header pointer" id="headingtext-counter" data-toggle="collapse"
                         data-target="#styleElementtext-counter" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-text-counter-headline') }}
                      </h5>
                    </div>
                    <div id="styleElementtext-counter" class="collapse show" aria-labelledby="headingtext-counter"
                         >
                      <div class="card-body">
                        <text-counter-component ref="textCounter"
                                                v-show="resourcesActive.textCounter"></text-counter-component>
                        <text-style-component ref="textStyleCounter"
                                              v-show="resourcesActive.textStyleCounter"></text-style-component>

                      </div>
                    </div>
                  </div>

                  <div class="accordion-settings" v-show="resourcesActive.subTextNext">
                    <div class="card-header pointer" id="headingSubNextButton" data-toggle="collapse"
                         data-target="#styleElementSubNextButton" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">{{ $t('ct-button-sub-next-headline') }}</h5>
                    </div>
                    <div id="styleElementSubNextButton" class="collapse show" aria-labelledby="headingSubButton"
                         >
                      <div class="card-body">
                        <input-component ref="subTextNext" v-show="resourcesActive.subTextNext"></input-component>
                        <text-style-component ref="subTextStyleNext"
                                              v-show="resourcesActive.subTextStyleNext"></text-style-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.subTextPrevious">
                    <div class="card-header pointer" id="headingSubPreviousButton" data-toggle="collapse"
                         data-target="#styleElementSubPreviousButton" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">{{ $t('ct-button-sub-previous-headline') }}</h5>
                    </div>
                    <div id="styleElementSubPreviousButton" class="collapse show" aria-labelledby="headingSubButton"
                         >
                      <div class="card-body">
                        <input-component ref="subTextPrevious" v-show="resourcesActive.subTextPrevious"></input-component>
                        <text-style-component ref="subTextStylePrevious"
                                              v-show="resourcesActive.subTextStylePrevious"></text-style-component>
                      </div>
                    </div>
                  </div>

                  <!-- BLOG START-->
                  <div class="accordion-settings" v-show="resourcesActive.blogColor1">
                    <div class="card-header pointer" id="heading-blogColorConfig" data-toggle="collapse"
                         data-target="#blogColorConfig" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-blog-colors-headline') }}
                      </h5>
                    </div>
                    <div id="blogColorConfig" class="collapse show" aria-labelledby="heading-blogColorConfig"
                         >
                      <div class="card-body">
                        <box-color-component ref="blogColor1" v-show="resourcesActive.blogColor1"></box-color-component>
                        <box-color-component ref="blogColor2" v-show="resourcesActive.blogColor2"></box-color-component>
                        <box-color-component ref="blogColor3" v-show="resourcesActive.blogColor3"></box-color-component>
                        <box-color-component ref="blogColor4" v-show="resourcesActive.blogColor4"></box-color-component>
                        <box-color-component ref="blogColor5" v-show="resourcesActive.blogColor5"></box-color-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.blogImageHeight">
                    <div class="card-header pointer" id="heading-blogContentSizes" data-toggle="collapse"
                         data-target="#blogContentSizes" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-blog-sizes-headline') }}
                      </h5>
                    </div>
                    <div id="blogContentSizes" class="collapse show" aria-labelledby="heading-blogContentSizes"
                         >
                      <div class="card-body">
                        <slider-component ref="blogImageHeight" v-show="resourcesActive.blogImageHeight"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="blogImageWidth" v-show="resourcesActive.blogImageWidth"
                                          class="hide-resource-on-mobile"></slider-component>

                        <slider-component ref="blogContentHeight" v-show="resourcesActive.blogContentHeight"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="blogContentWidth" v-show="resourcesActive.blogContentWidth"
                                          class="hide-resource-on-mobile"></slider-component>

                        <slider-component ref="blogTitleHeight" v-show="resourcesActive.blogTitleHeight"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="blogTitleWidth" v-show="resourcesActive.blogTitleWidth"
                                          class="hide-resource-on-mobile"></slider-component>

                        <slider-component ref="blogButtonDivHeight" v-show="resourcesActive.blogButtonDivHeight"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="blogButtonDivWidth" v-show="resourcesActive.blogButtonDivWidth"
                                          class="hide-resource-on-mobile"></slider-component>

                        <slider-component ref="blogButtonHeight" v-show="resourcesActive.blogButtonHeight"
                                          class="hide-resource-on-mobile"></slider-component>
                        <slider-component ref="blogButtonWidth" v-show="resourcesActive.blogButtonWidth"
                                          class="hide-resource-on-mobile"></slider-component>

                        <slider-component ref="blogCardHeight" v-show="resourcesActive.blogCardHeight"
                                          class="hide-resource-on-mobile"></slider-component>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-settings" v-show="resourcesActive.blogButtonBorderRadius">
                    <div class="card-header pointer" id="heading-blogButtonBorderRadius"
                         data-toggle="collapse"
                         data-target="#blogButtonBorderRadius" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-radius') }}
                      </h5>
                    </div>
                    <div id="blogButtonBorderRadius" class="collapse show" aria-labelledby="heading-blogButtonBorderRadius"
                         >
                      <div class="card-body">

                        <label v-show="resourcesActive.blogCardBorderRadius" style="margin-left: 14px" for="">Card
                          radius</label>
                        <border-radius-component ref="blogCardBorderRadius"
                                                 v-show="resourcesActive.blogCardBorderRadius"></border-radius-component>

                        <label v-show="resourcesActive.blogThumbnailBorderRadius" style="margin-left: 14px" for="">Thumbnail
                          radius</label>
                        <border-radius-component ref="blogThumbnailBorderRadius"
                                                 v-show="resourcesActive.blogThumbnailBorderRadius"></border-radius-component>


                        <label v-show="resourcesActive.blogButtonBorderRadius" style="margin-left: 14px" for="">Button
                          radius</label>
                        <border-radius-component ref="blogButtonBorderRadius"
                                                 v-show="resourcesActive.blogButtonBorderRadius"></border-radius-component>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-settings" v-show="resourcesActive.blogTitleStyle">
                    <div class="card-header pointer" id="heading-blogTitleStyle" data-toggle="collapse"
                         data-target="#blogTitleStyle" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-blog-title-style-headline') }}
                      </h5>
                    </div>
                    <div id="blogTitleStyle" class="collapse show" aria-labelledby="heading-blogTitleStyle"
                         >
                      <div class="card-body">
                        <text-style-component ref="blogTitleStyle"
                                              v-show="resourcesActive.blogTitleStyle"></text-style-component>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-settings" v-show="resourcesActive.blogContentStyle">
                    <div class="card-header pointer" id="heading-blogContentStyle" data-toggle="collapse"
                         data-target="#blogContentStyle" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-blog-content-style-headline') }}
                      </h5>
                    </div>
                    <div id="blogContentStyle" class="collapse show" aria-labelledby="heading-blogContentStyle"
                         >
                      <div class="card-body">
                        <text-style-component ref="blogContentStyle"
                                              v-show="resourcesActive.blogContentStyle"></text-style-component>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-settings" v-show="resourcesActive.blogButtonStyle">
                    <div class="card-header pointer" id="heading-blogButtonStyle" data-toggle="collapse"
                         data-target="#blogButtonStyle" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-blog-button-style-headline') }}
                      </h5>
                    </div>
                    <div id="blogButtonStyle" class="collapse show" aria-labelledby="heading-blogButtonStyle"
                         >
                      <div class="card-body">
                        <text-style-component ref="blogButtonStyle"
                                              v-show="resourcesActive.blogButtonStyle"></text-style-component>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-settings" v-show="resourcesActive.blogAuthorStyle">
                    <div class="card-header pointer" id="heading-blogAuthorStyle" data-toggle="collapse"
                         data-target="#blogAuthorStyle" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-blog-author-style-headline') }}
                      </h5>
                    </div>
                    <div id="blogAuthorStyle" class="collapse show" aria-labelledby="heading-blogAuthorStyle"
                         >
                      <div class="card-body">
                        <text-style-component ref="blogAuthorStyle"
                                              v-show="resourcesActive.blogAuthorStyle"></text-style-component>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-settings" v-show="resourcesActive.blogCategoriesStyle">
                    <div class="card-header pointer" id="heading-blogCategoriesStyle" data-toggle="collapse"
                         data-target="#blogCategoriesStyle" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-blog-categories-style-headline') }}
                      </h5>
                    </div>
                    <div id="blogCategoriesStyle" class="collapse show" aria-labelledby="heading-blogCategoriesStyle"
                         >
                      <div class="card-body">
                        <text-style-component ref="blogCategoriesStyle"
                                              v-show="resourcesActive.blogCategoriesStyle"></text-style-component>
                      </div>
                    </div>
                  </div>

                  <!-- alan inicio -->

                  <div class="accordion-settings" v-show="resourcesActive.subTextContent">
                    <div class="card-header pointer" id="headingBlogContent" data-toggle="collapse"
                         data-target="#styleElementBlogContent" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-button-blog-content-style-headline') }}
                      </h5>
                    </div>
                    <div id="styleElementBlogContent" class="collapse show" aria-labelledby="headingBlogContent"
                         >
                      <div class="card-body">
                        <!-- <input-component ref="subTextContent" v-show="resourcesActive.subTextContent"></input-component> -->
                        <text-style-component
                          ref="subTextContent"
                          v-show="resourcesActive.subTextContent"
                        />

                        <!-- Blog news slider -->
                        <box-color-component
                          ref="blogInfoContentColor"
                          v-show="resourcesActive.blogInfoContentColor"
                        />

                        <!-- Blog news slider -->
                        <slider-component
                          ref="blogInfoContentHeight"
                          v-show="resourcesActive.blogInfoContentHeight"
                        />

                        <!-- Blog news slider -->
                        <padding-component
                          ref="blogInfoContentPadding"
                          v-show="resourcesActive.blogInfoContentPadding"></padding-component>
                      </div>
                    </div>
                  </div>


                  <!-- alan fim -->

                  <div class="accordion-settings" v-show="resourcesActive.itemMenuTextStyle">
                    <div class="card-header pointer" id="headingitemMenuTextStyle" data-toggle="collapse"
                         data-target="#itemMenuTextStyle" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-item') }}
                      </h5>
                    </div>
                    <div id="itemMenuTextStyle" class="collapse show" aria-labelledby="headingitemMenuTextStyle"
                         >
                      <div class="card-body">
                        <slider-component ref="spacing" v-show="resourcesActive.spacing"></slider-component>
                        <slider-component ref="itemMenuHeight"
                                          v-show="resourcesActive.itemMenuHeight"></slider-component>
                        <slider-component ref="itemMenuWidth" v-show="resourcesActive.itemMenuWidth"></slider-component>
                        <text-style-component ref="itemMenuTextStyle"
                                              v-show="resourcesActive.itemMenuTextStyle"></text-style-component>
                        <border-component ref="itemMenuBorder"
                                          v-show="resourcesActive.itemMenuBorder"></border-component>
                        <border-radius-component ref="itemMenuBorderRadius"
                                                 v-show="resourcesActive.itemMenuBorderRadius"></border-radius-component>
                        <box-color-component ref="btnStyleBackgroundColor"
                                             v-show="resourcesActive.btnStyleBackgroundColor"></box-color-component>
                        <box-color-component ref="btnStyleBackgroundColorHover"
                                             v-show="resourcesActive.btnStyleBackgroundColorHover && this.device !== 'mobile'"></box-color-component>
                        <box-color-component ref="btnStyleTextColorHover"
                                             v-show="resourcesActive.btnStyleTextColorHover && this.device !== 'mobile'"></box-color-component>
                        <box-color-component ref="btnStyleBackgroundColorActive"
                                             v-show="resourcesActive.btnStyleBackgroundColorActive"></box-color-component>
                        <box-shadow-component ref="itemMenuBoxShadow"
                                              v-show="resourcesActive.itemMenuBoxShadow"></box-shadow-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.arrowLeft">
                    <div class="card-header pointer" id="headingitemArrowLeft" data-toggle="collapse"
                         data-target="#itemMenuArrowLeft" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-arrow-left') }}
                      </h5>
                    </div>
                    <div id="itemMenuArrowLeft" class="collapse show" aria-labelledby="headingitemArrowLeft"
                         >
                      <div class="card-body">
                        <arrow-component v-show="resourcesActive.arrowLeft" ref="arrowLeft"></arrow-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.arrowRight">
                    <div class="card-header pointer" id="headingitemArrowRight" data-toggle="collapse"
                         data-target="#itemMenuarrowRight" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-arrow-right') }}
                      </h5>
                    </div>
                    <div id="itemMenuarrowRight" class="collapse show" aria-labelledby="headingitemarrowRight"
                         >
                      <div class="card-body">
                        <arrow-component v-show="resourcesActive.arrowRight" ref="arrowRight"></arrow-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.arrowTop">
                    <div class="card-header pointer" id="headingitemarrowTop" data-toggle="collapse"
                         data-target="#itemMenuarrowTop" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-arrow-top') }}
                      </h5>
                    </div>
                    <div id="itemMenuarrowTop" class="collapse show" aria-labelledby="headingitemarrowTop"
                         >
                      <div class="card-body">
                        <arrow-component v-show="resourcesActive.arrowTop" ref="arrowTop"></arrow-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.arrowBottom">
                    <div class="card-header pointer" id="headingitemarrowBottom" data-toggle="collapse"
                         data-target="#itemMenuarrowBottom" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-arrow-bottom') }}
                      </h5>
                    </div>
                    <div id="itemMenuarrowBottom" class="collapse show" aria-labelledby="headingitemarrowBottom"
                         >
                      <div class="card-body">
                        <arrow-component v-show="resourcesActive.arrowBottom" ref="arrowBottom"></arrow-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.itemMenuSubTextStyle">
                    <div class="card-header pointer" id="headingitemMenuSubTextStyle" data-toggle="collapse"
                         data-target="#itemMenuSubTextStyle" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-sub-item') }}
                      </h5>
                    </div>
                    <div id="itemMenuSubTextStyle" class="collapse show" aria-labelledby="headingitemMenuSubTextStyle"
                         >
                      <div class="card-body">
                        <text-style-component ref="itemMenuSubTextStyle"
                                              v-show="resourcesActive.itemMenuSubTextStyle"></text-style-component>
                        <border-component ref="itemMenuSubBorder"
                                          v-show="resourcesActive.itemMenuSubBorder"></border-component>
                        <box-color-component ref="btnSubStyleBackgroundColor"
                                             v-show="resourcesActive.btnSubStyleBackgroundColor"></box-color-component>
                        <box-color-component ref="btnSubStyleBackgroundColorHover"
                                             v-show="resourcesActive.btnSubStyleBackgroundColorHover && this.device !== 'mobile'"></box-color-component>
                        <box-color-component ref="btnSubStyleTextColorHover"
                                             v-show="resourcesActive.btnSubStyleTextColorHover && this.device !== 'mobile'"></box-color-component>
                        <box-color-component ref="btnSubStyleBackgroundColorActive"
                                             v-show="resourcesActive.btnSubStyleBackgroundColorActive"></box-color-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.buttonSearchBar">
                    <div class="card-header pointer" id="headingbuttonSearchBar" data-toggle="collapse"
                         data-target="#itembuttonSearchBar" aria-expanded="true"
                         aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-button-style') }}
                      </h5>
                    </div>
                    <div id="itembuttonSearchBar" class="collapse show" aria-labelledby="headingbuttonSearchBar"
                         >
                      <div class="card-body">
                        <text-style-component ref="buttonSearchBar"
                                              v-show="resourcesActive.buttonSearchBar"></text-style-component>
                        <box-color-component ref="btnBlogStyleBackgroundColor"
                                             v-show="resourcesActive.btnBlogStyleBackgroundColor"></box-color-component>
                        <box-color-component ref="btnBlogStyleBackgroundColorHover"
                                             v-show="resourcesActive.btnBlogStyleBackgroundColorHover"></box-color-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.cursorType">
                    <div class="card-header pointer" id="headingShadow" data-toggle="collapse"
                         data-target="#styleElementBoxShadow" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-cursorType') }}
                      </h5>
                    </div>
                    <div id="styleElementBoxShadow" class="collapse show" aria-labelledby="headingShadow"
                         >
                      <div class="card-body">
                        <select-component ref="cursorType"
                                          v-show="resourcesActive.cursorType"></select-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.boxShadow">
                    <div class="card-header pointer" id="headingShadow" data-toggle="collapse"
                         data-target="#styleElementBoxShadow" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-shadow') }}
                      </h5>
                    </div>
                    <div id="styleElementBoxShadow" class="collapse show" aria-labelledby="headingShadow"
                         >
                      <div class="card-body">
                        <box-shadow-component ref="boxShadow"
                                              v-show="resourcesActive.boxShadow"></box-shadow-component>
                        <box-shadow-component ref="boxShadowNext"
                                              v-show="resourcesActive.boxShadowNext"></box-shadow-component>
                        <box-shadow-component ref="boxShadowPrevious"
                                              v-show="resourcesActive.boxShadowPrevious"></box-shadow-component>
                        <box-shadow-component ref="dropdownBoxShadow"
                                              v-show="resourcesActive.dropdownBoxShadow"></box-shadow-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.parallax">
                    <div class="card-header pointer" id="headingparallax" data-toggle="collapse"
                         data-target="#styleElementparallax" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-parallax') }}
                      </h5>
                    </div>
                    <div id="styleElementparallax" class="collapse show" aria-labelledby="headingparallax"
                         >
                      <div class="card-body">
                        <parallax-component ref="parallax"
                                            v-show="resourcesActive.parallax"></parallax-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.animation">
                    <div class="card-header pointer" id="headingAnimation" data-toggle="collapse"
                         data-target="#styleElementAnimation" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-animation') }}
                      </h5>
                    </div>
                    <div id="styleElementAnimation" class="collapse show" aria-labelledby="headingAnimation"
                         >
                      <div class="card-body">
                        <animation-component v-show="resourcesActive.animation" ref="animationIn"
                                             type="in"></animation-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.divider">
                    <div class="card-header pointer" id="headingDivider" data-toggle="collapse"
                         data-target="#styleElementDivider" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-divider') }}
                      </h5>
                    </div>
                    <div id="styleElementDivider" class="collapse show" aria-labelledby="headingAdvanced"
                         >
                      <div class="card-body">
                        <divider-component ref="divider" v-show="resourcesActive.divider"></divider-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings" v-show="resourcesActive.tag">
                    <div class="card-header pointer" id="headingTag" data-toggle="collapse"
                         data-target="#styleElementTag" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-tag-config') }}
                      </h5>
                    </div>
                    <div id="styleElementTag" class="collapse show" aria-labelledby="headingTag"
                         >
                      <div class="card-body">
                        <tag-component v-show="resourcesActive.tag" ref="tag"></tag-component>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-settings">
                    <div class="card-header pointer" id="headingAdvanced" data-toggle="collapse"
                         data-target="#styleElementAdvanced" aria-expanded="true" aria-controls="collapseOne">
                      <h5 class="mb-0 ellipsis dropdown-arrow">
                        {{ $t('ct-adv') }}
                      </h5>
                    </div>
                    <div id="styleElementAdvanced" class="collapse show" aria-labelledby="headingAdvanced"
                         >
                      <div class="card-body">
                        <fixed-component ref="fixed" v-show="resourcesActive.fixed"
                                         class="only-first-panel"></fixed-component>
                        <z-index-component ref="zIndex" v-show="resourcesActive.zIndex"></z-index-component>
                        <anchor-component ref="anchor" v-show="resourcesActive.anchor"></anchor-component>
                        <padding-component ref="padding" v-show="resourcesActive.padding" class="padding-mobile"
                                           style="display: none;"></padding-component>
                        <margin-component ref="margin" v-show="resourcesActive.margin" class="padding-mobile"
                                          style="display: none;"></margin-component>
                        <save-item-component ref="saveItem"></save-item-component>
                      </div>
                    </div>

                    <!-- SMART TAG -->
                    <!--<div v-show="resourcesActive.smartTag" class="card-header pointer" id="headingAdvanced" data-toggle="collapse"
                         data-target="#smartTag" aria-expanded="false" aria-controls="collapseOne">
                      <h5 class="mb-0">
                        {{ $t('ct-smart-tag') }}
                      </h5>
                    </div>
                    <div id="smartTag" class="collapse" aria-labelledby="headingAdvanced"
                         >
                      <div class="card-body">
                        <smart-tag-component ref="smartTag" v-show="resourcesActive.smartTag"></smart-tag-component>
                      </div>
                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="personal" class="tab-pane fade personal-tab-content">
            <div class="mt-3 mx-4">
              <h6 v-html="$t('ct-personal-tab-help')"></h6>
            </div>
            <ul class="nav nav-tabs nav-tabs-outline justify-content-flex-start">
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#personalPanel">
                  {{ $t('ct-panel') }}
                </a>
              </li>
              <li class="nav-item" @click="getPersonalItems()">
                <a class="nav-link add-personal-elem" data-toggle="tab" href="#personalElem">
                  {{ $t('ct-elements') }}
                </a>
              </li>
            </ul>
            <div class="tab-content  tab-bg">
              <div id="personalPanel" class="tab-pane fade internal-tab my-4">
                <template v-if="user_blocks.length > 0">
                  <div v-for="(child,key) in orderUserItems('blocks')" :key="key"
                       class="element-default-user">

                    <div class="card accordion-settings">
                      <div class="card-header pointer" data-toggle="collapse"
                           :data-target="`#collapse${child.name}`" aria-expanded="false"
                           :aria-controls="`#collapse${child.name}`">
                        <h5 class="mb-0 ellipsis dropdown-arrow">
                          {{ $t(`ct-${(child.name.replace('Element', '')).toLowerCase()}`) }}
                        </h5>
                      </div>
                      <div class="collapse" :id="`collapse${child.name}`" data-parent="#accordionUserItems">
                        <div class="card-body">
                          <div class="collapse-user-items" v-for="(item,index) in child.items" :key="index">
                            <div class="add-style d-flex justify-content-between align-items" :data-ref="item.name" :data-childs="JSON.stringify(item.childs)"><div class="collapse-user-items-description"><strong>{{item.description}}</strong></div><div class="collapse-user-items-actions">
                               <span @click="addDefaultBlock(item , 'user')" data-ba-i="add-personal-panel"> <font-awesome-icon
                                 :icon="['fa', 'plus']" class="font-awesome-icon primary"
                                 style="height: 1.0em"/> </span>
                                <span @click="deleteUserElementModal(item)"> <font-awesome-icon
                                  :icon="['far', 'trash-alt']"
                                  v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
                                  class="font-awesome-icon danger"
                                  style="height: 1.0em"/> </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <div class="text-center mx-4" v-else>
                  <p>{{ $t('ct-personal-panel-empty') }}</p>
                </div>
              </div>
              <div id="personalElem" class="tab-pane fade internal-tab">
                <div class="accordion my-4" id="accordionUserItems">
                  <template v-if="user_apps.length > 0">
                  <div v-for="(child,key) in orderUserItems('apps')" :key="key"
                       class="element-default-user">
                    <div class="card  accordion-settings">
                      <div class="card-header pointer" data-toggle="collapse"
                           :data-target="`#collapse${child.name}`" aria-expanded="false"
                           :aria-controls="`#collapse${child.name}`">
                        <h5 class="mb-0 ellipsis dropdown-arrow">
                          {{ $t(`ct-${(child.name.replace('Component', '')).toLowerCase()}`)}}
                        </h5>
                      </div>
                      <div class="collapse" :id="`collapse${child.name}`" data-parent="#accordionUserItems">
                        <div class="card-body">
                          <div class="collapse-user-items" v-for="(item,index) in child.items" :key="index"
                               style="text-align: center;">
                            <div class="addElement add-style d-flex justify-content-between align-items" :data-ref="item.name" :data-config="item.config"
                                 data-ba-i="add-personal-element"
                                 :data-childs="JSON.stringify(item.childs)"><div class="collapse-user-items-description collapse-user-items-elmts"><strong>{{item.description}}</strong></div><div class="collapse-user-items-actions">
                                <span @click="deleteUserElementModal(item)"> <font-awesome-icon
                                  :icon="['far', 'trash-alt']"
                                  v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
                                  class="font-awesome-icon danger"
                                  style="height: 1.0em"/> </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </template>
                  <div class="text-center mx-4" v-else>
                    <p>{{ $t('ct-personal-elemts-empty') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
         <!-- <button class="btn btn-primary" @click="addBaseElement('LottieFileComponent')">LottieFileComponent</button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FixedComponent from '../../resources/Fixed';

import ArrowComponent from '../../resources/Arrow';

import {getDefaultItems} from '../../../../js/services/editor/defaultItem';
import {get as getUserItems, remove as deleteUserItem} from '../../../../js/services/editor/userDefaultItems';
import FontList from '../FontList';
import CheckComponent from '../../resources/Check';
import SaveItemComponent from '../../resources/SaveItem';
import ZIndexComponent from '../../resources/ZIndex';
import AlignMenuComponent from '../../resources/AlignMenu';
import TagComponent from '../../resources/Tag';
import ParallaxComponent from '../../resources/Parallax';
import ArrowConfigComponent from '../../resources/ArrowConfig';
import TextCounterComponent from '../../resources/TextCounter';
import DividerComponent from '../../resources/Divider';
import VideoComponent from '../../resources/Video';

//resource_components
import BlogSearchComponentOptions from '../../apps/Blog/Search/Options'
import BoxComponentOptions from '../../apps/Box/Options'
import BoxHoverComponentOptions from '../../apps/BoxHover/Options'
import ImageComponentOptions from '../../apps/Image/Options'
import Image3DComponentOptions from '../../apps/Image3D/Options'
import CheckoutComponentOptions from '../../apps/Checkout/Form/Options'
import PanelComponentOptions from '../../apps/Panel/Options'
import LaunchAppComponentOptions from '../../apps/Forms/Launch/Options'
import VideoComponentOptions from '../../apps/Video/Options'
import LottieFileComponentOptions from '../../apps/LottieFile/Options.vue'
import FloatingButtonComponentOptions from '../../apps/FloatingButton/Options'

// import Vue from 'vue'
  // import SmartTagComponent from "../SmartTag"

  require('./rightBar.scss');

  export default {
    name: 'EditionSidebarComponent',
    props: ['hasRestrictsArea', 'device'],
    components: {
      //OPTIONS
      BlogSearchComponentOptions,
      BoxComponentOptions,
      BoxHoverComponentOptions,
      ImageComponentOptions,
      Image3DComponentOptions,
      CheckoutComponentOptions,
      PanelComponentOptions,
      LaunchAppComponentOptions,
      VideoComponentOptions,
      FloatingButtonComponentOptions,
      // SmartTagComponent,
      VideoComponent,
      DividerComponent,
      TextCounterComponent,
      ArrowConfigComponent,
      ParallaxComponent,
      TagComponent,
      AlignMenuComponent,
      ArrowComponent,
      FixedComponent,
      ZIndexComponent,
      SaveItemComponent,
      CheckComponent,
      LottieFileComponentOptions,
      'icon-component': () => import('../../resources/Icon'),
      'image-component': () => import('../../resources/Image'),
      'slider-component': () => import('../../resources/Slider'),
      'input-component': () => import('../../resources/Input'),
      'input-radio-component': () => import('../../resources/InputRadio'),
      'text-area-component': () => import('../../resources/TextArea'),
      'text-style-component': () => import('../../resources/TextStyle'),
      'box-color-component': () => import('../../resources/BoxColor'),
      'border-component': () => import('../../resources/Border'),
      'box-shadow-component': () => import('../../resources/BoxShadow'),
      'animation-component': () => import('../../resources/Animation'),
      'border-radius-component': () => import('../../resources/BorderRadius'),
      'padding-component': () => import('../../resources/Padding'),
      'margin-component': () => import('../../resources/Margin'),
      'anchor-component': () => import('../../resources/Anchor'),
      'youtube-src-component': () => import('../../resources/YoutubeSrc'),
      'vimeo-src-component': () => import('../../resources/VimeoSrc'),
      'select-component': () => import('../../resources/Select'),
      'date-component': () => import('../../resources/Date'),
      'wistia-src-component': () => import('../../resources/WistiaSrc'),
      'webinar-src-component': () => import('../../resources/WebinarSrc'),
      'socialbar-component': () => import('../../resources/SocialBar'),
      'blog-component': () => import('../../resources/Blog'),
      'vidello-src-componenet': () => import('../../resources/VidelloSrc'),
      'link-component': () => import('../../resources/Link'),
      //resource_components

    },
    data() {
      return {
        elementsLoaded: false,
        activeSidebar: '',
        textElementPlaced: false,
        warning: false,
        element: null,
        activeTab: {},
        translations: [],
        new_apps: [],
        new_blocks: [],
        user_apps: [],
        user_blocks: [],
        showSidebar: true,
        elementEdition: '',
        burguerTranslation: '',
        resourcesActive: {
          elementName: '',

          width: false,
          height: false,

          textStyleCounter: false,
          textCounter: false,

          src: false,
          fontSize: false,
          spacing: false,
          itemMenuBorder: false,
          itemMenuBorderRadius: false,
          fixed: false,
          fontSizeMobile: false,
          backgroundColor: false,
          checkBoxTextBackgroundHover: false,
          textBackgroundColorHover: false,
          backgroundColorContainer: false,
          internalBackgroundColor: false,
          internalSrc: false,
          backgroundColorBar: false,
          hover: true,
          backgroundColorHover: false,
          backgroundColorSelected: false,
          textColorSelected: false,
          backgroundColorEffect: false,
          cursorType: false,
          textColorHover: false,
          border: false,
          borderContainer: false,
          boxShadow: false,
          arrowConfig: false,
          anchor: false,
          video: false,
          divider: false,
          textarea: false,
          menuMobileEffect: false,
          sizeIcon: false,
          burguerMenuPosition: false,
          burguerMenuIcon: false,
          burguerMenuColor: false,
          burguerMenuBackground: false,
          brandImage: false,
          brandPosition: false,
          brandWidth: false,
          padding: false,
          margin: false,
          inputStyle: false,
          inputBorder: false,
          inputHeight: false,
          textareaHeight: false,
          buttonMargin: false,
          inputColor: false,
          labelStyle: false,
          placeholderColor: false,
          youtubeSrc: false,
          maxWidth: false,
          alignMenu: false,

          webinarSrc: false,
          vimeoSrc: false,
          Wistia: false,
          webinarId: false,
          webinarSecret: false,

          zIndex: false,
          fullWidth: false,
          fullHeight: false,
          inlineHtml: false,
          borderRadiusContainer: false,
          minHeight: false,
          showLabel: false,
          showTitle: false,
          showDescription: false,
          showPreviousButton: false,
          showPlaceholder: false,
          timerSlider: false,
          arrowOptions: false,
          arrowColor: false,
          arrowSize: false,
          autoPlaySlider: false,

          label: false,
          itemMenuTextStyle: false,
          itemMenuHeight: false,
          itemMenuWidth: false,
          itemMenuSubTextStyle: false,
          itemMenuSubBorder: false,
          btnStyleBackgroundColor: false,
          btnStyleBackgroundColorHover: false,
          btnStyleTextColorHover: false,
          btnStyleBackgroundColorActive: false,
          btnSubStyleBackgroundColor: false,
          btnSubStyleBackgroundColorHover: false,
          btnSubStyleTextColorHover: false,
          btnSubStyleBackgroundColorActive: false,

          subStyle: false,
          animation: false,
          tag: false,

          alt: false,
          title: false,
          paddingContainer: false,
          heightContainer: false,
          positionContainer: false,
          widthContainer: false,

          enableOnlyLink: false,
          enableLineBreak: false,

          /**
           * Image Gallery
           */
          columns: false,
          imagesPerPage: false,
          galleryTheme: false,
          verticalMargin: false,
          horizontalMargin: false,
          bottomMargin: false,
          typeOpenContainer: false,
          navigationWithNumber: false,
          navigationBackground: false,
          navigationHover: false,
          navigationActive: false,

          arrowLeft: false,
          arrowBottom: false,
          arrowTop: false,
          arrowRight: false,
          timer: false,
          btnUser: false,
          widthPanels: false,
          fontColor: false,
          textDescription: false,

          // smartTag: false,

          SocialBar: false,
          PlaceMenu: false,
          parallax: false,
          textLogin: false,
          textLogout: false,

          //  blog
          blogTitleStyle: false,
          blogContentStyle: false,
          blogButtonStyle: false,
          blogAuthorStyle: false,
          blogCategoriesStyle: false,
          blogButtonBorderRadius: false,
          blogThumbnailBorderRadius: false,
          blogCardBorderRadius: false,
          blogContentSizes: false,
          blogImageWidth: false,
          blogImageHeight: false,
          blogContentWidth: false,
          blogContentHeight: false,
          blogTitleWidth: false,
          blogTitleHeight: false,
          blogButtonHeight: false,
          blogButtonWidth: false,
          blogButtonDivHeight: false,
          blogButtonDivWidth: false,
          blogCardHeight: false,
          blogColor1: false,
          blogColor2: false,
          blogColor3: false,
          blogColor4: false,
          blogColor5: false
        },
        fontList: null,
        fontOptions: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'],
        tabs: [
          {
            title: 'Style',
            href: 'style-tab',
            id: 'style',
            isActive: true
          },
          {
            title: 'animation',
            href: 'animation-tab',
            id: 'animation'
          }
        ]
      };
    },
    methods: {
      replaceTranslations(text){
        return text.replace(/\s+/g, '-').toLowerCase()
      },

      changeOrderPanel(data) {
          this.$parent.changeOrderPanel(data)
      },

      hideCategories() {

        $('.add-panel-label').hide();
        $('.place-categories').hide();
        $('.add-blank-panel').hide();
        $('.add-panel-return').show();

      },

      showCategories() {
        $('.add-panel-label').show();
        $('.place-categories').show();
        $('.add-blank-panel').show();
        $('.add-panel-return').hide();

        $('.collapse.categories-c').removeClass('show');
      },


      hideElements() {

        $('.add-panel-label-elem').hide();
        $('.place-categories-elem').hide();
        $('.add-panel-return-elem').show();

      },

      checkIfElementsAreLoaded() {
        //console.info('apps loaded => ' + this.new_apps.length)
        //console.info('blocks loaded => ' + this.new_blocks.length)

        if(this.new_apps.length && this.new_blocks.length) {
          this.elementsLoaded = true;
          return;
        }

        setTimeout(() => {
          this.checkIfElementsAreLoaded();
        }, 1500);
      },

      showElements() {
        $('.add-panel-label-elem').show();
        $('.place-categories-elem').show();
        $('.add-panel-return-elem').hide();

        $('.collapse.elements-c').removeClass('show');
      },

      deleteUserElementModal(item) {
        this.$snotify.warning('Do you really want to delete this item?', 'Delete', {
          timeout: 5000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [
            {text: 'Yes', action: () => this.deleteUserElement(item), bold: false},
            {text: 'No', action: () => console.log('dont')}
          ]
        });
      },

      deleteUserElement(item) {
        deleteUserItem(item)
          .then(res => {
            if (res.data.success) {
              this.$snotify.info(
                'Deleted'
              );
              this.getPersonalItems();
            }
          });
      },

      showThumbnail(source) {
        let url = '';
        if (process.env.NODE_ENV === 'development') {
          url = 'http://localhost:8087/storage/';
        } else {
          url = 'https://sitebuilder-admin.omb11.com/storage/';
        }
        url = 'https://sitebuilder-admin.omb11.com/storage/';
        return 'url("' + url + source + '")';
      },

      checkCategoryComponent(component) {
        if (component.show === 0 || component.items_active.length < 1) {
          return false;
        } else {
          if(component.items_active) {
            let membersComponents = component.items_active.find(active => parseInt(active.category_id) === 79);
            if (!this.hasRestrictsArea && !!membersComponents)
              return false;
          }
          return true;
        }
      },

      checkComponent(component) {
        if (component.show === 0 || component.thumbnail == null || component.thumbnail == '') {
          return false;
        } else {
          return true;
        }
      },

      addBasePanel() {
        this.$parent.addDefaultBlock([{
          id: 'vai trocar mesmo',
          name: 'PanelElement',
          config: {},
          childs: [{
            id: 'tem que trocar',
            name: 'TextComponent',
            config: {
              'top': '20px',
              'left': '150px',
              'order_mobile': 2,
              'showDesktop': true,
              'showMobile': true,
              'tag': 'h2',
              'content': '<h2 class="default" style="text-align: center;">' + this.$t('ct-title-h2-blank-panel') + '</h2>',
              'width': '800px',
              'fontSizeMobile': '28px',
              'animation': {
                'in': {
                  'action': 'time',
                  'time': 0,
                  'scroll': 0,
                  'effect': 'none',
                  'speed': 'slow',
                  'infinite': false
                },
                'out': {
                  'action': 'time',
                  'time': 0,
                  'scroll': 0,
                  'effect': 'none',
                  'delay': '1',
                  'speed': '1',
                  'infinite': false
                }
              },
              'zIndex': 'auto',
              'paddingTop': '5px',
              'paddingLeft': '5px',
              'paddingRight': '5px',
              'paddingBottom': '5px'
            }
          }]
        }]);
      },

      addCheckoutTeste(elem) {
        this.$parent.addElementWithClick('LaunchAppComponent', {})
      },

      addBaseElement(elem) {
        this.$parent.addBaseElement(elem, {
          "width": "419px",
          "height": "212px",
          "minHeight": "50px",
          "zIndex": 1,
          "maxWidth": "500px",
          "background": "#FFFFFF",
          "backgroundColor": "#C3BCBC00",
          "borderRadius": "0 0 0 0",
          "paddingTop": "15px",
          "paddingLeft": "15px",
          "paddingRight": "15px",
          "paddingBottom": "15px",
          "url": "https://assets5.lottiefiles.com/packages/lf20_FM14VPPBpz.json",
          "code": "",
          "speed": 1,
          "autoplay": true,
          "loop": true,
          "controls": false,
          "showDesktop": true,
          "showMobile": true,
          "tag": "",
          "top": "96px",
          "left": "65px"
        });
      },

      addDefaultBlock(data, type = 'default') {
        if (type === 'user') {
          let aux = data;
          data = [];
          data[0] = aux;
          if (typeof data[0].config !== 'object') {
            data[0].config = JSON.parse(data[0].config);
          }
        }

        this.$parent.addDefaultBlock(data);
      },

      changeTab(active) {
        this.tabInfo.active = active;
      },
      hideResources() {
        for (let i in this.resourcesActive) {
          this.resourcesActive[i] = false;
        }
      },
      show() {
        this.showSidebar = !this.showSidebar;
        if (this.showSidebar == true) {
          this.hideTabs();

          $('.add-tab').addClass('active');
          $('.add-tab-content').addClass('active show');
          $('.add-element-tab').addClass('active');
          $('.add-element-tab-content').addClass('active show');

          $('.off-sidebar').removeClass('off-sidebar').addClass('default-sidebar');

          if($('.off-sidebar').length == 0){
            $('.modal-header-sidebar').show();
          }else{
            $('.modal-header-sidebar').hide();
          }
        }
      },
      hideSidebar() {
        this.showSidebar = false;

        if($('.default-sidebar').length == 0){
          $('.modal-header-sidebar').show();
        }else{
          $('.modal-header-sidebar').hide();
        }

        $('.default-sidebar').removeClass('default-sidebar').addClass('off-sidebar');

      },

      getPersonalItems() {
        this.user_apps = [];
        this.user_blocks = [];

        getUserItems()
          .then((res) => {
            res.data.apps.forEach(item => {
              let content = JSON.parse(item.content);
              item.config = content.config;
              item.childs = content.childs;
              this.user_apps.push(item);
            });
            res.data.blocks.forEach(item => {
              let content = JSON.parse(item.content);
              item.config = content.config;
              item.childs = content.childs;
              this.user_blocks.push(item);
            });
            this.activeDrop();
          });
      },

      orderUserItems(param) {
        let objFormat = [];
        let objFormat2 = [];
        let array = [];

        if (param === 'blocks') {
          array = this.user_blocks;
        } else {
          array = this.user_apps;
        }

        if (array.length > 0) {
          Object.keys(array).map(index => {
            objFormat[array[index].name] = array[index];
          });

          Object.keys(objFormat).forEach(index => {
            let obj = {name: index, items: []};
            objFormat2.push(obj);
          });

          Object.keys(objFormat2).forEach(index => {
            Object.keys(array).forEach(index2 => {
              if (array[index2].name === objFormat2[index].name) {
                objFormat2[index].items.push(array[index2]);
              }
            });
          });
        }

        //
        // console.log(array);
        return objFormat2;
      },

      // vai assim mesmo, fodasse
      hideTabs() {
        let actives = document.getElementsByClassName('panel-components-right')[0].getElementsByClassName('active');
        [].forEach.call(actives, function (el) {
          el.classList.remove('active');
          el.classList.remove('show');
        });

        let actives2 = document.getElementsByClassName('panel-components-right')[0].getElementsByClassName('active');
        [].forEach.call(actives2, function (el) {
          el.classList.remove('active');
          el.classList.remove('show');
        });

        let actives3 = document.getElementsByClassName('panel-components-right')[0].getElementsByClassName('active');
        [].forEach.call(actives3, function (el) {
          el.classList.remove('active');
          el.classList.remove('show');
        });
      },

      activeDrop() {

        let vm = this;

        this.$nextTick(function () {
          $('.addElement')
            .draggable({
              hoverClass: 'ui-state-active',
              revert: true,
              helper: 'clone',
              cursor: 'move',
              tolerance: 'pointer',
              opacity: 0.70,
              connectToSortable: '.panel-body',
              start: function (e, ui) {
                $('.add-element-tab-content').css({'overflow-x': 'unset', 'position': 'fixed'});
              },
              stop: function () {
                $('.add-element-tab-content').css({'overflow-x': 'scroll', 'position': 'static'});
              },
            })
            .click(function () {
              const element = this;

              /* O Elemento Texto é chamado três vezes quando clicado, isso bloquea os outros dois clicks */
              if ($(element).data('isclicked')) return true;

              $(element).data('isclicked', true);

              setTimeout(() => {
                $(element).data('isclicked', false);
              }, 1000);

              const componentName = element.getAttribute('data-ref');
              const elementConfig = element.getAttribute('data-config');

              vm.$parent.addElementWithClick(componentName, JSON.parse(elementConfig));
            });
        });
      },

      openInfoVideos() {
        // if (this.user_apps.length === 0 & this.user_blocks.length === 0)
        // 	this.$emit('openInfoHelper', 'savePanelsTab');
      },


      dir() {
        let defaultLocale = (window.getCookie('languageEditorUser') != null) ? window.getCookie('languageEditorUser') : 'en_US';
        if (
          defaultLocale === 'he_IL' ||
          defaultLocale === 'ja_JP' ||
          defaultLocale === 'ar_AR'
        ) {
          return 'rtl';
        } else return false;
      },

      hSidebarEdition() {
        this.hideResources();
        $('#tab-add-panel').trigger('click');
      },

      hiderSidebarEdition() {
        this.showSidebar = false;
      },

      rigthSidebarEdition(element) {

        let vm = this;

        vm.hideTabs();

        $('.settings-tab').addClass('active');
        $('.settings-tab-content').addClass('active show');
        $('.settings-style-tab').addClass('active');
        $('.settings-style-tab-content').addClass('active show');

        this.element = element;
        this.showSidebar = true;

        let elementName = 'ct-component-' + element.$el.attributes.element.value;


        if (typeof element.$el.attributes['data-is-drip'] !== 'undefined' && element.$el.attributes['data-is-drip'].value) {
          elementName += 'Drip'
        }


        if (elementName === 'ct-component-VideoGalleryComponent') {
          this.burguerTranslation = this.$t('ct-icon-close-config')
        } else {
          this.burguerTranslation = this.$t('ct-burguer-menu')
        }

        this.elementEdition = this.$t(elementName);

        this.hideResources();

        this.warning = elementName === 'ct-component-VideoGalleryGroupComponent';

        this.activeSidebar = `${elementName.replace('ct-component-', '')}Options`;

        if (typeof element.sidebar !== 'undefined' && element.sidebar === '2') {

          vm.$nextTick( () => {

            //id panel to sort
            if(element.$el.attributes.element.value === 'PanelComponent'){
              let config = element.internal_config;
              config.id = element.$refs.elem.id;
              let childs = _.clone(element.childs);
              vm.$refs[vm.activeSidebar].init(config, childs,  element.build);
            }else{
              vm.$refs[vm.activeSidebar].init(element.internal_config, element.build);
            }

          } )

          this.$refs.saveItem.setValues(element);


        } else {
          try {
            if (typeof element !== 'undefined') {
              let resourcesElement = element.showResources();
              for (let i in resourcesElement) {
                // console.log(resourcesElement[i].name);
                this.resourcesActive[resourcesElement[i].name] = true;

                if (typeof element.animation() !== 'undefined') {
                  this.resourcesActive.animation = element.animation();
                }

                /* Timer */
                if (typeof element.internal_config.name !== 'undefined' && element.internal_config.name === 'timer') {
                  this.resourcesActive.timer = element.internal_config;
                }

                this.resourcesActive.elementName = element.internal_config.name ? element.internal_config.name : '';
                if (typeof element.internal_config.name !== 'undefined' && element.internal_config.name === 'ButtonUser') {
                  this.resourcesActive.btnUser = element.internal_config;
                }

                /* Social Bar */
                if (typeof element.internal_config.name !== 'undefined' && element.internal_config.name === 'SocialBar') {
                  this.resourcesActive.SocialBar = element.internal_config;
                }

                if (typeof element.internal_config.name !== 'undefined' && element.internal_config.name === 'big-menu-place') {
                  this.resourcesActive.PlaceMenu = element.internal_config;
                }

                if (this.$refs[resourcesElement[i].name]) {
                  this.$refs[resourcesElement[i].name].setValues(resourcesElement[i], element)
                } else {
                  console.error('not found', resourcesElement[i].name)
                }
              }

              let animationData = element.internal_config.animation;
              if (typeof animationData !== 'undefined') {
                this.$refs.animationIn.setValues(animationData['in'], element)
              }

              this.resourcesActive.tag = true;
              this.$refs.tag.setValues(element.internal_config.tag, element);
              if (
                elementName !== 'ct-component-VideoGalleryComponent'
              ) {
                this.resourcesActive.tag = true;
                this.$refs.tag.setValues(element.internal_config.tag, element);
              }


              if (
                elementName === 'ct-component-BlogArticleListComponent' ||
                elementName === 'ct-component-blog-news-slider-component' ||
                elementName === 'ct-component-BlogPostComponent' ||
                elementName === 'ct-component-BlogRssComponent' ||
                elementName === 'ct-component-BlogSearchComponent' ||
                elementName === 'ct-component-ButtonUserComponent' ||
                elementName === 'ct-component-ContentNavUserComponent'
              ) {
                this.resourcesActive.tag = false;
              }


              this.$refs.saveItem.setValues(element);

              if (typeof element.internal_config.flag !== 'undefined' && element.internal_config.flag === '') {
                this.resourcesActive.fontSizeMobile = false;
              }
            }
          } catch (e) {
            console.log(e, element);
          }
        }
      },

      showSidebarEdition() {
        this.showSidebar = !this.showSidebar;
        if (this.showSidebar == true) {
          this.hideTabs();

          $('.add-tab').addClass('active');
          $('.add-tab-content').addClass('active show');
          $('.add-element-tab').addClass('active');
          $('.add-element-tab-content').addClass('active show');

          $('.off-sidebar').removeClass('off-sidebar').addClass('default-sidebar');
        }
      }
    },

    mounted() {

      let vm = this;

      this.fontList = FontList.data().props.fontList;

      this.getPersonalItems();

      this.$root.$on('rSidebarEdition', (elem)=>{
        vm.rigthSidebarEdition(elem);
      })

      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari)  // safari abrir sempre em sidebar
        $('#settingsElements').addClass('default-safari');

      getDefaultItems()
        .then((res) => {
          this.new_apps = [];
          this.new_blocks = [];

          const isBundle = localStorage.getItem('is_bundle') === 'exit-popup';

          const enabledBundleApps = new Set([
            'Contact Form',
            'Image',
            'Iframe',
            'Lines',
            'Button',
            'Timer',
            'Social Bars',
            'Video',
          ]);

          const disabledBundleBlocks = new Set([
            'Calendar Page',
            'Checkout Page',
            'Confirm Email Page',
            'Membership Area',
            'Optin',
            'Webinar Broadcast',
            'Webinar Confirmation',
            'Webinar Indocrination',
            'Webinar Replay',
          ]);

          res.data.forEach(category => {
            if (isBundle) {
              if (category.type === 'app' && !enabledBundleApps.has(category.title)) return;
              if (category.type === 'block' && disabledBundleBlocks.has(category.title)) return;
            }

            if (category.type === 'app') {
              this.new_apps.push(category);
            }

            if (category.type === 'block') {
              this.new_blocks.push(category);
            }
          });

          this.new_apps.forEach(category => {
            var titleTranslated = (' ' + category.title).slice(1);
            category['title_translated']  = titleTranslated.split('.').join('-').replace(/\s+/g, '-').toLowerCase();
            category['tutorial_link'] = false;

            if(category.translation_key_tutorial && this.$t(category.translation_key_tutorial) !== category.title_translated){
              category['tutorial_link'] = this.$t(category.translation_key_tutorial);
            }

            category.items_active.forEach(item => {
              try {
                item.config = JSON.parse(item.content).config;
                if (typeof JSON.parse(item.content).childs !== 'undefined') {
                  item.childs = JSON.parse(item.content).childs
                }
              } catch (e) {
                console.log('error append element sidebar', e, item);
              }
            });
          });

          this.new_blocks.forEach(category => {
            var titleTranslated = (' ' + category.title).slice(1);
            category['title_translated']  = titleTranslated.split('.').join('-').replace(/\s+/g, '-').toLowerCase();

            category.items_active.forEach(item => {
              try {
                item.config = JSON.parse(item.content);
              } catch (e) {
                console.log('error append block sidebar', item);
              }
            });
          });

          this.activeDrop();
        });
    }
  };
</script>

<style>
.elements-c-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid lightgray;
  width: 300px;
  padding-top: 30px
}

.elements-c-title a {
  color: #212529;
  transition: all;
}

.elements-c-title a:hover {
  opacity: .7;
}

.danger {
    color: #ff1317;
  }

  .primary {
    color: #0396FF;
  }

  .element-icon {
    font-size: 25px;
    width: 100%;
    height: 15px;
    cursor: pointer;
    vertical-align: middle;
  }

  .custom-range {
    width: 100% !important;
  }

  .label-range-custom {
    width: 100% !important;
  }

  #addpanel-tab-list h5, #accordionStyleElement h5, #personalPanel h5, #pageFont h5, #accordionUserItems h5 {
    line-height: 29px;
    font-family: "Muli";
  }

  #addpanel-tab-list h6 {
    font-family: "Muli";
    font-weight: bold;
  }

  #styleElementBackgroundPage .form-group {
    padding: 0px 15px;
  }

  .card-header h5 {
    font-size: 1.15em;
  }

  .addElement.ui-draggable-dragging {
    margin-top: -150px;
  }
div.imgSocialBar img{
    padding: 5px !important;
    max-width: 150px;
    max-height: 150px;
    margin-left: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/editor/base/sidebar/RightSidebar.vue